/**
 * DirectTalk
 *  ダイレクトトークのメッセージ保存や、送信を行う。
 */
import moment from 'moment'
import directtalk from '@/api/directtalk'
import auth from '@/api/auth'
import format from '@/functions/format'
import session from '@/api/session'
import _ from 'lodash'

moment.locale('ja')
export default {
  namespaced: true,
  state: {
    // 多すぎ、変数整理すること
    roomcount: 0,
    ws: null,
    wslist: null,
    wsroom: null,
    sessionId: localStorage.getItem('sessionid') || null,
    directTalkAllRoom: {
      all: [],
    },
    roomlist: {
      active: [],
      star: [],
      search: [],
      all: [],
      query: [],
    },
    roomnumber: 0,
    typing: '',
    selectroom: {
      name: '',
      group: '',
      isOnline: '',
      count: '',
      readTime: null,
    },
    isConnectRoom: false,
    isConnectList: false,
    isConnectWidgetRoom: false,
    isLoaded: false,
    messageCompleted: false,
    messageError: false,
    messageLoading: false,
    isMessageError: false,
    isReconnect: false,
    isChatLogs: false,
    chatLogs: [],
    chatLogs2: [],
    chatLogs3: [],
    readLogs: [],
    receives: {
      message: '',
    },
    data: {
      name: null,
      url: null,
      appname: null,
      platform: null,
      width: null,
      height: null,
      color: null,
      refferer: '',
      useragent: null,
      ckey: '',
      cookies: null,
      count: 0,
    },
    seeker: {
      id: null,
      name: null,
      email: null,
      date: null,
      time: null,
      count: 0,
      scout: null,
    },
    chatData: {
      message: '',
      name: '',
      url: '',
      email: '',
      speaker: 'my',
      icon: '',
      createdAt: '',
      sendToID: '',
      minibot_pk: '',
      sendToModel: '',
      scenarioNode: '',
      btnIdx: 0,
      isManager: '0',
      status: -1,
      parameter: {},
      appname: '',
      platform: '',
      refferer: '',
      useragent: '',
      count: 0,
    },
    messagePages: 1,
    own: null,
    mobileKey: 0,
    isMViewDList: true,
    isReadRoom: false,
    isScrollLoading: false,
    isSeekerCount: false,
    isSendedSeeker: false,
    widgetData: {
      users: [],
      name: '',
      action: '',
      count: 0,
      connectCount: 0,
      readTime: null,
      newMsgCount: 0,
      latest_author: '',
      isFavoriteView: false,
      isAuto: false,
    },
    widgetDataDemo: null,
    roomlistScroll: 1,
    isScroll: false,
    color: {
      iconBg: '#218BE9',
      iconFr: '#FFFFFF',
      header: '#218BE9',
      balloonMy: 'rgb(200, 220, 240)',
      balloonOtr: 'rgb(240, 255, 240)',
      sendBtn: '#218BE9',
      iconImage: '',
    },
    power: false,
    wdt: -1,
    targetID: '',
    targetModel: '',
    target: '',
    targetIcon: '',
    historyUrl: [
      {
        createdAt: ' ',
        url: ' ',
      },
    ],
    compareUrl: null,
    favoriteInfo: null,
    favoriteInfoList: null,
    chatLogsLoading: false,
    dashboardKPI: {
      seekerNewCount: 0,
      seekerOldCount: 0,
      seekerDauCount: 0,
    },
    isLoading: false,
    graphData: [],
    barDatacollection: {
      labels: [],
      datasets: [],
    },
    lineDatacollection: {
      labels: [],
      datasets: [],
    },
    graphCount: {
      dauCount: [],
      newCount: [],
      reseekerCount: [],
      iconCount: [],
      alreadyReadCount: [],
      replyCount: [],
      subscribeCount: [],
      useragentCount: [],
    },
    sumCount: {
      dau: 0,
      new: 0,
      reseeker: 0,
      icon: 0,
      alreadyRead: 0,
      reply: 0,
      subscribe: 0,
      useragent: 0,
    },
    toggleState: false,
    labels: [],
    datasets: [],
    resume: [],
    academic: [],
    career: [],
    qualification: [],
    selectTagNewMsg: 0,
    isOneReadImage: false,
    alreadyCount: 0,
    applylist: [],
    isApplyListLoading: false,
    isApplyListNone: false,
    downloadCSV: null,
    isMakingCSV: false,
    parsedSeekerData: null,
    isVideoInterview: false,
    pdfFile: null,
    csvFile: null,
    resumeLoading: false,
    isMakePDF: false,
    companiesList: [],
    lastmessage: [],
    lastreadmessage: [],
    scrolltalk: '',
    urlList: [],
    displayUrl: [],
    isUrl: '',
    isOCRReading: false,
    ocrData: null,
    updateSkFlg: false,
    isGetMessageMax: false,
    chatTalkHistory: [],
    // 再構築したseekers
    scoutSeekers: [],
    scoutCount: 0,
    seekers: [],
    qualifications: [],
    seekerfiles: [],
    customColumns: [],
    isSeekerLoading: false,
    isScoutSeekerLoading: false,
    getSeekerType: 'subscribe',
    isSendingEmail: false,
    isSavingCustomColumn: false,
    emailList: [],
    scoutHistoryies: [],
    recruitmentFlowActionHistoryies: [],
    tempScout: {
      name: null,
      type: 0,
      scout_image_ref: null,
      catch_copy: null,
      url: null,
      content: null,
      company: null,
      story: null,
      disp_size: 1.5,
    },
    emailAction: null,
    isEmailActionLoading: true,
    isEmailActionError: false,
    messageHistory: [],
    seekerInputInfos: [],
    cbInfoLoading: true,
    cbContactLoading: true,
    companyData: {},
    isCompanyDataLoading: true,
    seekerReplyList: [],
    seekerContactDone: false,
    seekerContactList: [],
    isFilteringError: false,
    seekerSync: null,
    sortFlg: false,
    filterFlg: false,
    recordingInterviews: [],
    answerRecord: null,
    detailRecord: null,
    pdfCreating: false,
    filteredSeekers: null,
    filteredSeekersNum: 0,
    seekerFilterItems: null,
    detailManage: [],
    roboArguments: [],
    aggregateResult: [],
    companyColumnResult: [],
    aggregatedMessagesResult: [],
    seekerSummaryTable2Result: [],
    yearMonthRange: null,
    seekerSummaryResult: [],
    seekerExportTemplates: [],
    emailListing: [],
    smsListing: [],
    actionListing: [],
  },
  actions: {
    /* チャットサーバーへの接続 */
    connect({ commit }, { uri, category }) {
      commit('CONNECT_BEGIN', { uri, category })
    },
    /* チャットサーバーの切断 */
    disconnect({ commit }) {
      commit('CONNECT_END')
    },
    /* チャットサーバー一覧への接続 */
    connectList({ commit }, uri) {
      commit('CONNECT_LIST', uri)
    },
    getRoomList({ commit }, data) {
      commit('GET_ROOM_LIST', data)
    },
    /* チャットの送信 */
    pushChat({ commit, rootState }, data) {
      commit('MESSAGE_BEGIN', { data: data, minipk: rootState.chatbot.minipk })
      commit('MESSAGE_SUCCESS', data)
      if (data.isManager === '1') {
        var all = {
          get_type: 'all',
        }
        commit('GET_ROOM_LIST', all)
      }
    },
    /* アクションの送信 */
    pushAction({ commit }, data) {
      commit('SET_ACTION', data)
    },
    /* スマホのキーボード出すときに入力フォームを移動 */
    mobileType({ commit }) {
      commit('MOBILE_TYPE')
    },
    /* 入力中...の送信 */
    isTyping({ commit }, message) {
      commit('MESSAGE_TYPING', message)
    },
    /* チャットルーム選択 */
    selectRoom({ commit }, data) {
      commit('SELECT_ROOM', data)
    },
    getUrlList({ commit }, data) {
      commit('GET_URL_LIST', data)
    },
    selectAction({ commit }, data) {
      commit('SELECT_ACTION', data)
    },
    /* seeker用の最初のデータ保存 */
    setJson({ commit }, data) {
      const token = localStorage.getItem('TOKEN_STORAGE_KEY')
      const isUser = localStorage.getItem('IS_USER')
      session.defaults.headers.Authorization = `JWT ${token}`
      session.defaults.withCredentials = true
      if (token && isUser === 'true') {
        auth
          .getAccountDetailsUser()
          .then((d) => {
            var jsonReplaceData = data
            var isSet = false
            for (var i in d.data.profileSeeker_info) {
              if (jsonReplaceData.ckey === d.data.profileSeeker_info[i].ckey) {
                if (d.data.profileSeeker_info[i].sessionid) {
                  jsonReplaceData.sessionid = d.data.profileSeeker_info[i].sessionid
                } else {
                  jsonReplaceData.sessionid = data.sessionid
                }
                isSet = true
              }
            }
            // 認証したが、まだ往訪したことがない場合はセット
            if (!isSet) {
              var pushData = d.data.profileSeeker_info
              pushData.push({
                sessionid: jsonReplaceData.sessionid,
                ckey: jsonReplaceData.ckey,
              })
              auth.setProfileSeekerInfo(pushData)
            }
            commit('SET_JSON', jsonReplaceData)
          })
          .catch((e) => {
            console.error('e: ' + JSON.stringify(e))
            delete session.defaults.headers.Authorization
            session.defaults.withCredentials = true
            commit('SET_JSON', data)
          })
      } else {
        delete session.defaults.headers.Authorization
        session.defaults.withCredentials = true
        commit('SET_JSON', data)
      }
    },
    setSeeker({ commit }) {
      commit('SET_SEEKER')
    },
    getSeekerData({ commit }, list) {
      commit('GET_SEEKER_DATA', list)
    },
    getSubscribedSeekers({ commit, rootState }, { conditions, authUser, isAgent }) {
      commit('LOAD_SEEKER', { id: 'subscribe', flg: true })
      conditions.authUser = authUser

      directtalk.getSubscribedSeekers(conditions)
        .then(async (d) => {
          // GetUser実行中の場合は終わるまで待つ
          while (rootState.auth.getUserWaiting) {
            await new Promise(resolve => setTimeout(resolve, 500))
          }

          //更新されている可能性があるため改めて取得し直し
          authUser = rootState.auth.users.filter((i) => i.email === rootState.auth.user.email)
          isAgent = rootState.auth.user.isAgent

          commit('SET_SUBSCRIBES_SEEKERS', {
            seekers_data: d.data,
            authUser: authUser,
            isAgent: isAgent,
          })
          commit('LOAD_SEEKER', { id: 'subscribe', flg: false })
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
          commit('LOAD_SEEKER', { id: 'subscribe', flg: false })
        })
    },
    getSeekerFilterItems({ commit }, conditions) {
      commit('setSeekerFilterItems', null)
      return directtalk.getSeekerFilterItems(conditions)
        .then((d) => {
          commit('setSeekerFilterItems', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
          return []
        })
    },
    searchSeeker({ commit }, searchInfo) {
      return directtalk
        .searchSeeker(searchInfo)
        .then((d) => {
          if (d.data) {
            return JSON.parse(d.data)
          } else {
            return []
          }
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
          return []
        })
    },
    setWDTSeeker({ commit }, data) {
      commit('SET_WDT_SEEKER', data)
    },
    updateOmit({ commit }, isOmit) {
      commit('UPD_OMIT', isOmit)
    },
    saveSeekerInfoCard({ commit }) {
      commit('SET_SEEKER_FROM_INFO')
    },
    createSeekerATHistory({ commit }, { target, action, url, element }) {
      commit('SET_SK_AT_HS', { target, action, url, element })
    },
    getMessage({ commit }, { name, pages }) {
      commit('GET_MESSAGE', { name, pages })
    },
    setChatLogsDemo({ commit }, chatLogsDemo) {
      commit('SET_CHAT_LOGS_DEMO', chatLogsDemo)
    },
    importMessage({ commit, rootState }, data) {
      commit('IMP_MESSAGE', data)
      commit('GET_MESSAGE', { name: data.name, pages: rootState.directtalk.messagePages })
    },
    getRoom({ commit }) {
      commit('GET_ROOM')
    },
    getRoomTemp({ commit }) {
      commit('GET_ROOM_TEMP')
    },
    getRoomDemo({ commit }, cid) {
      commit('GET_ROOM_DEMO', cid)
    },
    moreRoom({ commit }) {
      commit('MORE_ROOM')
    },
    getRoboInfo({ commit }, data) {
      return directtalk.getRoboInfo(data)
        .then((d) => {
          return d.data
        })
        .catch((err) => {
          return null
        })
    },
    /* 管理者用の最初のデータ保存 */
    setManager({ commit }, uri) {
      commit('SET_MANAGER', uri)
    },
    setDT({ commit }, { name, icon, id, model }) {
      commit('SET_DT', { name, icon, id, model })
    },
    async updateSeekerData({ commit }, data) {
      return await directtalk.setSeekerData(data)
        .then(() => {
          commit('UPDATE_SK')
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
        })
    },
    setCalendar({ commit }, data) {
      commit('SET_CALENDAR', data)
    },
    setWidgetReceive({ commit }, num) {
      commit('WIDGET_RECEIVE', num)
    },
    setIsRead({ commit }, speaker) {
      commit('SET_ISREAD', speaker)
    },
    addCount({ commit }, { uid, name, type }) {
      commit('ADD_COUNT', { uid, name, type })
    },
    seekerCount({ commit }, type) {
      commit('SEEKER_COUNT', type)
    },
    setStar({ commit }, { data, index }) {
      commit('SET_STAR', { data, index })
      var star = {
        get_type: 'star',
      }
      commit('GET_ROOM_LIST', star)
    },
    getGraphData({ commit }, data) {
      commit('GET_GRAPH_DATA', data)
    },
    toggleGraphLine({ commit }, lineName) {
      commit('TOGGLE_GRAPH_LINE', lineName)
    },
    openLoading({ commit }) {
      commit('OPEN_LOADING')
    },
    getReadCount({ commit }) {
      commit('GET_READ_COUNT')
    },
    createResume({ commit }, data) {
      data.data.photo = data.data.photo.replace(/^.*,/, '')
      directtalk
        .createResume(data)
        .then((d) => {
          commit('RESUME_CREATE', d.data)
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
          alert('エラーが発生しました。')
        })
    },
    createResumeDemo({ commit }, data) {
      data.data.photo = data.data.photo.replace(/^.*,/, '')
      directtalk
        .createResumeDemo(data.data)
        .then((d) => {
          commit('RESUME_CREATE_DEMO', d.data)
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
          alert('エラーが発生しました。')
        })
    },
    updateResume({ commit }, data) {
      commit('UPDATE_RESUME', data)
    },
    setManage({ commit }, data) {
      commit('SET_MANAGE', data)
    },
    getLastMessage({ commit }, { data, name, pages }) {
      commit('GET_LM', { data, name, pages })
    },
    getReadLastMessage({ commit }, { data, name, pages }) {
      commit('GET_RE_LM', { data, name, pages })
    },
    csvExport({ commit }, data) {
      commit('CSV_EXPORT', data)
    },
    async parseSeekerCSV({ commit }, data) {
      return await directtalk.parseSeekerCSV({ csv_str: data }).then((d) => {
        commit('SET_PARSED_SEEKER_DATA', d.data)
      })
    },
    createSeekerExportTemplate({ commit }, data) {
      directtalk.createSeekerExportTemplate(data).then((d) => {
        commit('setSeekerExportTemplate', { id: d.data.id, data: d.data })
      })
    },
    getSeekerExportTemplate({commit}, ) {
      directtalk.getSeekerExportTemplate()
        .then((d) => {
          commit('setSeekerExportTemplateList', d.data)
        })
    },
    updateSeekerExportTemplate({commit}, {id, data}) {
      directtalk.updateSeekerExportTemplate(id, data)
        .then((d) => {
          commit('setSeekerExportTemplate', {id: id, data: d.data})
        })
    },
    deleteSeekerExportTemplate({commit}, id) {
      directtalk.deleteSeekerExportTemplate(id)
        .then(() => {
          commit('setSeekerExportTemplate', {id: id, data: null})
        })
    },
    closeVideoInterview({ commit }) {
      commit('CLOSE_VIDEO_INTERVIEW')
    },
    scrollTalk({ commit }, data) {
      commit('SCROLL_TALK', data)
    },
    makeDialogCSV({ commit }, data) {
      commit('MAKE_DIALOG_CSV', data)
    },
    uploadOCR({ commit }, data) {
      commit('UPLOAD_OCR', data)
    },
    // Emailからアクセスした訪問者を識別するAPI
    async getFromEmailSeeker({ commit }, data) {
      return await directtalk
        .getFromEmailSeeker(data)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
          return e
        })
    },
    // 再構築したaction seekers
    async createSeeker({ commit }, data) {
      return await directtalk
        .createSeeker(data)
        .then((d) => {
          commit('CREATE_SEEKER', JSON.parse(d.data))
          return JSON.parse(d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
          return e
        })
    },
    async importSeeker({ commit }, data) {
      return await directtalk
        .importSeeker(data)
        .then((d) => {
          commit('IMPORT_SEEKER', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    async getSeeker({ commit }, id) {
      /**
       * 応募者情報を取得する
       * @param {string} id - 応募者ID
       * @returns {Promise<Object>} APIレスポンス
       */
      if (!id) {
        throw new Error('Seeker ID is required');
      }
      
      if (id === 'subscribe') {
        commit('LOAD_SEEKER', { id: id, flg: true });
      }
      
      try {
        const response = await directtalk.getSeeker(id);
        
        // レスポンスの検証
        if (!response || response.status !== 200) {
          throw new Error('Invalid response status');
        }
        
        if (!response.data || response.data === '') {
          throw new Error('Empty response data');
        }
        
        // データのコミット
        commit('GET_SEEKER', { data: response.data, id: id });
        
        if (id === 'subscribe') {
          commit('LOAD_SEEKER', { id: id, flg: false });
        }
        
        return response;
        
      } catch (error) {
        console.error('getSeeker error:', error);
        
        if (id === 'subscribe') {
          commit('LOAD_SEEKER', { id: id, flg: false });
        }
        
        // エラーの詳細情報を含めて再スロー
        const enhancedError = new Error(error.message || 'Failed to get seeker');
        enhancedError.response = error.response;
        enhancedError.originalError = error;
        
        throw enhancedError;
      }
    },
    filteredSeeker({ commit }, data) {
      commit('FILTER_ERR', false)
      commit('LOAD_SEEKER', { id: data.id, flg: true })
      directtalk
        .filteredSeeker(data)
        .then((d) => {
          commit('GET_SEEKER', { data: d.data, id: data.id })
          commit('LOAD_SEEKER', { id: data.id, flg: false })
          if (data.filtered) {
            if (d.data.data.length === 0) {
              commit('FILTER_ERR', true)
              alert('フィルタリング結果は０件でした。')
            } else {
              commit('FILTER_ERR', false)
            }
          }
        })
        .catch((e) => {
          console.error(e)
          commit('LOAD_SEEKER', { id: data.id, flg: false })
          commit('FILTER_ERR', true)
          alert('エラーが発生いたしました。')
        })
    },
    async updateSeeker({ commit }, data) {
      if (!Array.isArray(data)) data = [data]
      return await directtalk
        .updateSeeker(data)
        .then((d) => {
          let seekers = JSON.parse(d.data)
          for (let seeker of seekers) commit('UPDATE_SEEKER', seeker)
          return
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
          return
        })
    },
    updateSeekerAny({ commit }, data) {
      directtalk
        .updateSeekerAny(data)
        .then((d) => {
          commit('UPDATE_SEEKER', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteSeeker({ commit }, id) {
      directtalk
        .deleteSeeker(id)
        .then((d) => {
          commit('DELETE_SEEKER', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    outputSeekerPDF({commit}, data) {
      return directtalk.outputSeekerPDF(data)
    },
    isSeekerSubscribed({commit}, pk) {
      /**
       * Seekerの応募有無を取得する
       * @param {String} pk - Seekerのpk
       * @return {Bool} 応募済みかどうか
       */
      return directtalk.isSeekerSubscribed(pk)
        .then((d) => {
          return JSON.parse(d.data)
        })
        .catch((e) => {
          return false
        })
    },
    // 資格API
    createQualification({ commit }, data) {
      directtalk
        .createQualification(data)
        .then((d) => {
          commit('CREATE_QUALIFI', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    createQualificationAny({ commit }, data) {
      directtalk
        .createQualificationAny(data)
        .then((d) => {
          commit('CREATE_QUALIFI', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getQualification({ commit }, id) {
      directtalk
        .getQualification(id)
        .then((d) => {
          commit('GET_QUALIFI', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    async updateQualification({ commit }, data) {
      if (!Array.isArray(data)) data = [data]
      await directtalk
        .updateQualification(data)
        .then((d) => {
          if (d.data){
            let qualifs = JSON.parse(d.data)
            for (let qualif of qualifs) commit('UPDATE_QUALIFI', qualif)
          }
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteQualification({ commit }, id) {
      directtalk
        .deleteQualification(id)
        .then((d) => {
          commit('DELETE_QUALIFI', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // 学歴・職歴API
    createCareer({ commit }, data) {
      directtalk
        .createCareer(data)
        .then((d) => {
          commit('CREATE_CAREER', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    createCareerAny({ commit }, data) {
      directtalk
        .createCareerAny(data)
        .then((d) => {
          commit('CREATE_CAREER', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getCareer({ commit }, id) {
      directtalk
        .getCareer(id)
        .then((d) => {
          commit('GET_CAREER', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    async updateCareer({ commit }, data) {
      if (!Array.isArray(data)) data = [data]
      await directtalk
        .updateCareer(data)
        .then((d) => {
          if (d.data){
            let careers = JSON.parse(d.data)
            for (let career of careers) commit('UPDATE_CAREER', career)
          }
          })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteCareer({ commit }, id) {
      directtalk
        .deleteCareer(id)
        .then((d) => {
          commit('DELETE_CAREER', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteResume({ commit }, seeker_pk) {
      return directtalk.deleteResume(seeker_pk)
    },
    setPdfCreating({ commit }, flg) {
      commit('SET_PDF_CREATING', flg)
    },
    createResumePdf({ commit }, data) {
      return directtalk.createResumePdf(data)
    },
    // ファイルAPI
    createSeekerFiles({ commit }, data) {
      directtalk
        .createSeekerFiles(data)
        .then((d) => {
          commit('CREATE_SKFILES', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    createSeekerFilesAny({ commit }, data) {
      directtalk
        .createSeekerFilesAny(data)
        .then((d) => {
          commit('CREATE_SKFILES', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getSeekerFiles({ commit }, id) {
      directtalk
        .getSeekerFiles(id)
        .then((d) => {
          commit('GET_SKFILES', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateSeekerFiles({ commit }, data) {
      directtalk
        .updateSeekerFiles(data)
        .then((d) => {
          commit('UPDATE_SKFILES', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
        })
    },
    deleteSeekerFiles({ commit }, id) {
      directtalk
        .deleteSeekerFiles(id)
        .then((d) => {
          commit('DELETE_SKFILES', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // SeekerCustomColumns API
    createSeekerCustomColumns({ commit }, data) {
      commit('LOAD_CUSTOM', true)
      directtalk
        .createSeekerCustomColumns(data)
        .then((d) => {
          commit('CREATE_SCOL', { id: data.id, data: JSON.parse(d.data) })
          commit('LOAD_CUSTOM', false)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
          commit('LOAD_CUSTOM', false)
        })
    },
    getSeekerCustomColumns({ commit }, id) {
      directtalk
        .getSeekerCustomColumns(id)
        .then((d) => {
          commit('GET_SCOL', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    async updateSeekerCustomColumns({ commit }, data) {
      if (!Array.isArray(data)) data = [data]
      await directtalk
        .updateSeekerCustomColumns(data)
        .then((d) => {
          let columns = JSON.parse(d.data)
          for (let column of columns) commit('UPDATE_SCOL', { id: column.id, data: column })
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteSeekerCustomColumns({ commit }, id) {
      directtalk
        .deleteSeekerCustomColumns(id)
        .then((d) => {
          commit('DELETE_SCOL', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateOrCreateSeekerCustomColumns({ commit }, data) {
      if (!Array.isArray(data)) data = [data]
      const is_new = data.reduce((acc, item) => {
        acc[item.id] = item.pk === -1
        return acc
      }, {})

      return directtalk.updateOrCreateSeekerCustomColumns(data)
        .then((d) => {
          const columns = JSON.parse(d.data)
          for (let column of columns) {
            if (is_new[column.id]) {
              commit('CREATE_SCOL', { id: column.id, data: column })
            } else {
              commit('UPDATE_SCOL', { id: column.id, data: column })
            }
          }
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    sendEmailToSeeker({ commit }, email) {
      commit('SEND_MLSK', true)
      return new Promise((resolve, reject) => {
        directtalk
          .sendEmailToSeeker(email)
          .then((d) => {
            commit('SEND_MLSK', false)
            resolve(d)
          })
          .catch((e) => {
            reject(e.response.data.errors)
            commit('SEND_MLSK_ERR')
          })
      })
    },
    sendSMSToSeeker({ commit }, email) {
      commit('SEND_MLSK', true)
      return new Promise((resolve, reject) => {
        directtalk
          .sendSMSToSeeker(email)
          .then((response) => {
            commit('SEND_MLSK', false)
            resolve(response)
          })
          .catch((error) => {
            commit('SEND_MLSK_ERR')
            let errorData = {
              error_result_list: [],
              success_result_list: [],
              code: 'UNKNOWN_ERROR',
              total_count: 0,
              success_count: 0,
              error_count: 0
            }
            
            if (error.response) {
              // レスポンスデータをそのまま使用
              if (error.response.data) {
                errorData = {
                  ...errorData,
                  ...error.response.data
                }
              }
              
              // エラーリストが存在しない場合は、エラーメッセージから作成
              if (!errorData.error_result_list.length && error.response.data.errors) {
                const seekerList = email.seeker || []
                errorData.error_result_list = seekerList.map(seekerId => ({
                  seeker_id: seekerId,
                  status: 'バリデーションエラー',
                  error_code: 'VALIDATION_ERROR',
                  detail: error.response.data.errors
                }))
              }
            }
            
            reject(errorData)
          })
      })
    },
    async checkSMSJobStatus({ commit }, jobId) {
        return await directtalk.checkSMSJobStatus(jobId)
    },
    getSendedEmailList({ commit }, id) {
      return directtalk
        .getSendedEmailList(id)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getSendedSMSList({ commit }, id) {
      return directtalk
        .getSendedSMSList(id)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getCompanySMSHistory ({commit}, data) {
      directtalk.getCompanySMSHistory(data)
    },
    getEmailList({ commit }, {seeker_id}) {
      return directtalk.getEmailList(seeker_id)
        .then((d) => {
          commit('GET_EMAIL_LIST', d)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getEmailListing({ commit }) {
      return directtalk.getEmailListing()
        .then((d) => {
          commit('GET_EMAIL_LISTING', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getSmsListing({ commit }) {
      return directtalk.getSmsListing()
        .then((d) => {
          commit('GET_SMS_LISTING', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getActionListing({ commit }) {
      return directtalk.getActionListing()
        .then((d) => {
          commit('GET_ACTION_LISTING', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    sendMessage({ commit }, sendData) {
      return directtalk.sendMessage(sendData)
      .then((d) => {
        commit('SEND_MESSAGE', d)
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生いたしました。')
      })
    },
    getSendedBotEmailList({ commit }, bot_id) {
      return directtalk
        .getSendedBotEmailList(bot_id)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getReceivedSMSList({ commit }, data) {
      return directtalk
        .getReceivedSMSList(data)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getSendedScenarioEmailList({ commit }, bot_id) {
      return directtalk
        .getSendedScenarioEmailList(bot_id)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // ScoutHistory API
    createScoutHistory({ commit }, data) {
      directtalk
        .createScoutHistory(data)
        .then((d) => {
          commit('CREATE_SCTHIS', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    createScoutHistoryAny({ commit }, data) {
      return directtalk
        .createScoutHistoryAny(data)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          return null
        })
    },
    getScoutHistory({ commit }, id) {
      directtalk
        .getScoutHistory(id)
        .then((d) => {
          commit('GET_SCTHIS', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateScoutHistory({ commit }, data) {
      directtalk
        .updateScoutHistory(data)
        .then((d) => {
          commit('UPDATE_SCTHIS', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateScoutHistoryAny({ commit }, data) {
      directtalk
        .updateScoutHistoryAny(data)
        .then((d) => {
        })
        .catch((e) => {
          console.error(e)
        })
    },
    deleteScoutHistory({ commit }, id) {
      directtalk
        .deleteScoutHistory(id)
        .then((d) => {
          commit('DELETE_SCTHIS', { data: JSON.parse(d.data), id: id })
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // RecruitmentFlowActionHistory API
    createRecruitmentFlowActionHistory({ commit }, data) {
      return directtalk
        .createRecruitmentFlowActionHistory(data)
        .then((d) => {
          commit('CREATE_RFACTHIS', JSON.parse(d.data))
          alert('アクションが設定されました。')
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getRecruitmentFlowActionHistory({ commit }, id) {
      directtalk
        .getRecruitmentFlowActionHistory(id)
        .then((d) => {
          commit('GET_RFACTHIS', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateRecruitmentFlowActionHistory({ commit }, data) {
      return directtalk
        .updateRecruitmentFlowActionHistory(data)
        .then((d) => {
          commit('UPDATE_RFACTHIS', JSON.parse(d.data))
          alert('変更しました。')
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteRecruitmentFlowActionHistory({ commit }, id) {
      directtalk
        .deleteRecruitmentFlowActionHistory(id)
        .then((d) => {
          commit('DELETE_RFACTHIS', id)
          alert('削除しました。')
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    async unsubscribeAction({ commit }, seeker_id) {
      try {
        const response = await directtalk.unsubscribeAction(seeker_id)
        if (response.data.status === 'ok') {
          commit('UNSUBSCRIBE_ACTION', seeker_id)
          return response
        } else {
          throw new Error('Failed to unsubscribe action')
        }
      }
      catch (error) {
        console.error(error)
        alert('エラーが発生いたしました。')
        throw error
      }
    }, 
    getEmailAction({ commit }, data) {
      directtalk
        .getEmailAction(data)
        .then((d) => {
          commit('GET_EMAIL_ACT', d.data)
        })
        .catch((e) => {
          console.error(e)
          commit('ERR_EMAIL_ACT')
        })
    },
    createFromEmailActionHistory({ commit }, data) {
      directtalk
        .createFromEmailActionHistory(data)
        .then((d) => {
          if (data.action_history.recruit_status !== 2) {
            alert('設定が完了しました。ページを閉じます。')
            window.close()
          }
        })
        .catch((e) => {
          alert('エラーが発生しました。')
        })
    },
    fetchSeekerInputInfo({ commit }, cb) {
      return new Promise ((resolve, reject) => {
        directtalk.fetchSeekerInputInfo(cb)
        .then((d) => {
          const task_id = d.data.task_id

          const checkJobStatus = () => {
            return directtalk.checkFetchSeekerInputInfo(task_id)
            .then((d) => {
              if (d.data.completed) {
                commit('FETCH_SEEKER_INPUT_INFO', d.data.answers)
                resolve(d.data.answers)
              }
              else {
                setTimeout(checkJobStatus, 1000)
              }
            })
            .catch((e) => {
              reject(e)
            })
          }

          checkJobStatus()
        })
        .catch((e) => {
          console.error(e)
        })
      })
    },
    getCompanyData({ commit }, data) {
      const name = data.name
      const group = data.group
      if (name != null) {
        directtalk
          .getRoomData(name, group)
          .then((d) => {
            commit('GET_COMPANY_DATA', d.data)
          })
          .catch((e) => {
            console.error(e)
            alert('エラーが発生しました。')
          })
      }
    },
    sendSeekerReply({ commit }, data) {
      directtalk
        .sendSeekerReply(data)
        .then((d) => {
        })
        .catch((e) => {
          console.error(e)
        })
    },
    fetchSeekerReply({ commit }, data) {
      directtalk
        .fetchSeekerReply(data)
        .then((d) => {
          commit('FETCH_SEEKER_REPLY', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生しました。')
        })
    },
    sendSeekerContact({ commit }, data) {
      directtalk
        .sendSeekerContact(data)
        .then((d) => {
          commit('SEND_SEEKER_CONTACT')
        })
        .catch((e) => {
          alert('エラーが発生しました。')
        })
    },
    resetSeekerContactDone({ commit }) {
      commit('RESET_SEEKER_CONTACT_DONE')
    },
    fetchSeekerContact({ commit }, data) {
      directtalk
        .fetchSeekerContact(data)
        .then((d) => {
          commit('FETCH_SEEKER_CONTACT', d.data)
        })
        .catch((e) => {
          alert('エラーが発生しました。')
        })
    },
    createSeekerTagHistory({ commit }, data) {
      directtalk.createSeekerTagHistory(data)
    },
    getScoutGraph({ commit }) {
      return directtalk
        .getScoutGraph()
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('スカウトデータ取得時にエラーが発生いたしました。')
          return null
        })
    },
    setAllScout({ commit }, data) {
      return directtalk
        .setAllScout(data)
        .then(() => {
          alert('一括送付設定が完了しました。データを同期します。')
          return
        })
        .catch(() => {
          alert(
            '一括送付設定中にエラーが発生いたしました。再度送付しても同様のエラーが出る場合はお問い合わせください。データを同期するために再読み込みします。'
          )
          location.reload()
        })
    },
    // 請求用従量課金のデータ取得
    getBiilingData({ commit }, data) {
      return directtalk
        .getBiilingData(data)
        .then((d) => {
          return JSON.parse(d.data)
        })
        .catch(() => {
          alert(
            '従量課金用データを読み込みの際にエラーが発生いたしました。お問い合わせよりご連絡をお願いいたします。'
          )
          return null
        })
    },
    changeSortFlg({ commit }, flg) {
      commit('CHANGE_SORT_FLG', flg)
    },
    changeFilterFlg({ commit }, flg) {
      commit('CHANGE_FILTER_FLG', flg)
    },
    // 面接日程履歴保存
    async createInterviewHistory({ commit }, interviewHistory) {
      await directtalk.createInterviewHistory(interviewHistory)
        .catch((e) => {
          console.error(e)
        })
    },
    clearChatTalkHistory({ commit }) {
      commit('CLEAR_CHAT_HISTORY')
    },
    restoreTalkHistory({ commit }, id) {
      commit('RESTORE_TALK_HISTORY', id)
    },
    // 録画面接関連
    // RecordingInterview API
    createRecordingInterview({ commit }, data) {
      return directtalk
        .createRecordingInterview(data)
        .then((d) => {
          commit('CREATE_RI', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getRecordingInterview({ commit }, id) {
      return directtalk
        .getRecordingInterview(id)
        .then((d) => {
          // レスポンスデータの検証
          if (!d || !d.data) {
            console.error('APIレスポンスが不正:', d)
            throw new Error('データの取得に失敗しました')
          }

          // recording_contentが空の項目をログ
          d.data.forEach(item => {
            if (!item.recording_content || item.recording_content.length === 0) {
              console.warn(`ID: ${item.id} のrecording_contentが空です`, item)
            }
          })

          commit('GET_RI', d.data)
          return d.data  // データを返すように修正
        })
        .catch((e) => {
          console.error('録画面接データ取得エラー:', {
            エラー: e,
            エラーメッセージ: e.message,
            リクエストID: id
          })
          throw e  // エラーを上位に伝播
        })
    },
    getRecordingInterviewAny({ commit }, id) {
      return directtalk
        .getRecordingInterviewAny(id)
        .then((d) => {
          return JSON.parse(d.data)
        })
        .catch((e) => {
          console.error(e)
          alert(
            '大変申し訳ございません。録画面接情報が取得できませんでした。\nURLが誤っているかサーバーが混雑している可能性がございます。\n大変お手数をお掛け致しますが、本ブラウザを閉じてください。'
          )
        })
    },
    updateRecordingInterview({ commit }, data) {
      return directtalk
        .updateRecordingInterview(data)
        .then((d) => {
          commit('UPDATE_RI', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    deleteRecordingInterview({ commit }, id) {
      directtalk
        .deleteRecordingInterview(id)
        .then((d) => {
          commit('DELETE_RI', id)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    // RecordingContent API
    createRecordingContent({ commit }, data) {
      return directtalk
        .createRecordingContent(data)
        .then((d) => {
          commit('CREATE_RC', d.data)
          return true
        })
        .catch((e) => {
          console.error(e)
          return false
        })
    },
    updateRecordingContent({ commit }, data) {
      directtalk
        .updateRecordingContent(data)
        .then((d) => {
          commit('UPDATE_RC', d.data)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    deleteRecordingContent({ commit }, id) {
      directtalk
        .deleteRecordingContent(id)
        .then((d) => {
          commit('DELETE_RC', id)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    // RecordingAnswer API
    async createRecordingAnswer({ commit }, data) {
      await directtalk.createRecordingAnswer(data)
    },
    getRecordingAnswer({ commit }, data) {
      return directtalk
        .getRecordingAnswer({ id: data.content.id, id2: data.page })
        .then((d) => {
          commit('GET_RA', JSON.parse(d.data))
          return JSON.parse(d.data)
        })
        .catch((e) => {
          console.error(e)
          return []
        })
    },
    updateRecordingAnswer({ commit }, _data) {
      let data = _.cloneDeep(_data)
      // 回答動画がファイルではなくURLなので消しておく
      delete data.answer_recording
      return directtalk
        .updateRecordingAnswer(data)
        .then((d) => {
          commit('UPDATE_RA', { content: JSON.parse(d.data), change: 'rate' })
          alert('セーブしました。')
        })
        .catch((e) => {
          console.error(e)
        })
    },
    updateRecordingReadAnswer({ commit }, _data) {
      let data = _.cloneDeep(_data)
      // 回答動画がファイルではなくURLなので消しておく
      delete data.answer_recording
      directtalk
        .updateRecordingReadAnswer(data)
        .then((d) => {
          commit('UPDATE_RA', { content: JSON.parse(d.data), change: 'read' })
        })
        .catch((e) => {
          console.error(e)
        })
    },
    updateRecordingSelectSeeker({ commit }, data) {
      directtalk
        .updateRecordingSelectSeeker(data)
        .then((d) => {
          commit('UPDATE_RS', data)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getRecordingAnswerSeeker({ commit }, id) {
      return directtalk
        .getRecordingAnswerSeeker(id)
        .then((d) => {
          return JSON.parse(d.data)
        })
        .catch((e) => {
          console.error(e)
          return []
        })
    },
    getRecordingDetail({ commit }, id) {
      return directtalk
        .getRecordingDetail(id)
        .then((d) => {
          commit('GET_RD', d.data)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    // Eメール送付（録画面接後）
    async completeRecordingAnswerNotify({ commit }, data) {
      await directtalk.completeRecordingAnswerNotify(data)
    },
    initializeChatLogs({ commit }) {
      commit('INIT_LOGS')
    },
    createCompleteRecordingAnswerInfo({ commit }, data) {
      return directtalk
        .createCompleteRecordingAnswerInfo(data)
        .then((d) => {
          return d
        })
        .catch((e) => {
          return e
        })
    },
    async updateCompleteRecordingAnswerInfo({ commit }, data) {
      await directtalk.updateCompleteRecordingAnswerInfo(data)
    },
    interviewedUserDuplicateCheck({ commit }, data) {
      return directtalk
        .interviewedUserDuplicateCheck(data)
        .then((d) => {
          return d
        })
        .catch((e) => {
          return e
        })
    },
    refleshSeekerColomn({ commit }) {
      commit('REFLESH_SEEKER_COLUMN')
    },
    async getAutoFlow({ commit }) {
      return await directtalk.getAutoFlow()
    },
    async createAutoFlow({ commit }, data) {
      return await directtalk.createAutoFlow(data)
    },
    async deleteAutoFlow({ commit }, id) {
      return await directtalk.deleteAutoFlow(id)
    },
    async setAutoAction({ commit }, botId) {
      await directtalk.setAutoAction(botId)
    },
    async getSeekerOne({ commit }, data) {
      // console.log("UID:"+data.uid)  // デバッグ用ログ（必要に応じてコメントアウトを解除）
      const res = await directtalk.getSeekerOne(
        {
          id: data.id,
          uid: data.uid,
          isDuplicateSeekerFlag: data.isDuplicateSeekerFlag,
          isGetRoboTalk: data.isGetRoboTalk
        })
      return res
    },
    async deleteInterviewHistory({ commit }, data) {
      return await directtalk.deleteInterviewHistory(data)
    },
    async getInterviewHistory({ commit }, id) {
      return await directtalk.getInterviewHistory(id)
    },
    async bulkUpdateSeekerManage({commmit}, data) {
      await directtalk.bulkUpdateSeekerManage(data)
      .then((d) => {
        return d
      })
      .catch((e) => {
        alert('エラーが発生しました')
        return e
      })
    },
    async getSeekerDetailManage({commit}, data) {
      await directtalk.getSeekerDetailManage(data)
      .then((d) => {
        commit('GET_SDM', d.data)
        return d
      })
      .catch((e) => {
        alert('エラーが発生しました')
        return e
      })
    },
    async getSubscribeChangeHistory({commit}, seeker_id) {
      return await directtalk.getSubscribeChangeHistory(seeker_id)
      .then((d) => {
        return JSON.parse(d.data)
      })
      .catch((e) => {
        alert('エラーが発生しました')
        return e
      })
    },
    async getRoboArgumentsData({commit}, argumentsParam) {
      return await directtalk.getRoboArgumentsData(argumentsParam)
      .then((res) => {
        commit('SET_ROBO_ARG', res.data)
        return true
      })
      .catch((e) => {
        alert('エラーが発生しました')
        return false
      })
    },
    // 採用フロー停止設定（期間）
    async getPauseFlow({ commit }) {
      return await directtalk.getPauseFlow()
    },
    async createPauseFlow({ commit }, data) {
      return await directtalk.createPauseFlow(data)
    },
    async deletePauseFlow({ commit }, id) {
      return await directtalk.deletePauseFlow(id)
    },
    // 応募者ブラックリスト
    async getApplicantBlacklist({ commit }) {
      return await directtalk.getApplicantBlacklist()
    },
    async createApplicantBlacklist({ commit }, data) {
      return await directtalk.createApplicantBlacklist(data)
    },
    async deleteApplicantBlacklist({ commit }, id) {
      return await directtalk.deleteApplicantBlacklist(id)
    },
    async importApplicantBlacklist({ commit }, file) {
      const formData = new FormData()
      formData.append('csv_file', file)
      
      try {
        const response = await directtalk.importApplicantBlacklist(formData)
        return response
      } catch (error) {
        throw error
      }
    },
    getDetailSheetContents({commit}, {seeker_id, template_id}) {
      return directtalk.getDetailSheetContents(seeker_id, template_id)
    },
    updateDetailSheetContents({commit}, data) {
      if (!Array.isArray(data)) data = [data]
      return directtalk.updateDetailSheetContents(data)
    },
    outputDetailSheet({commit}, data) {
      return directtalk.outputDetailSheet(data)
    },
    // 応募者解析レポート用
    async aggregateSeekers({ commit }, data) {
      try {
        const response = await directtalk.aggregateSeekers(data);
        commit('SET_AGGREGATE_RESULT', response.data);
        return response; // Promise を返す
      } catch (error) {
        console.error(error);
      }
    },
    // ロボ稼働レポート用
    async aggregatedMessages({ commit }, data) {
      try {
        const response = await directtalk.aggregatedMessages(data);
        commit('SET_AGGREGATED_MESSAGES_RESULT', response.data);
        return response; // Promise を返す
      } catch (error) {
        console.error(error);
      }
    },
    // カスタムカラムを取得する。
    async companyReportColumns({ commit }, data) {
      try {
        const response = await directtalk.companyReportColumns(data);
        commit('SET_COMPANY_COLUMN_RESULT', response.data);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    // カスタムカラムを更新する。
    async updateCompanyReportColumns({ commit }, data) {
      try {
        const response = await directtalk.updateCompanyReportColumns(data);
        commit('SET_COMPANY_COLUMN_RESULT', response.data);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    // 最新のレポート用のカラムでサマリーテーブルを更新する。
    async updateSeekerSummaryTable2({ commit }, seekerSummaryTable2Data) {
      try {
        const response = await directtalk.updateSeekerSummaryTable2(seekerSummaryTable2Data);
        commit('SET_SEEKER_SUMMARY_TABLE2_RESULT', response.data);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    // レポートの絞り込み用に選ばれた選択肢を表示させる
    async fetchFilterOptions({ commit }) {
      try {
        const response = await directtalk.fetchFilterOptions();
        commit('SET_FILTER_OPTIONS', response.data);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    // レポートで、その会社の応募者の年月の最大値と最小値を取ってくる
    async fetchYearMonthRange({ commit }, data) {
      try {
        const response = await directtalk.fetchYearMonthRange(data);
        commit('SET_YEAR_MONTH_RANGE', response.data);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    // directtalk_seekerのサマリーテーブルを集計・表示させる
    async fetchSeekerSummary({ commit }, data) {
      try {
        const response = await directtalk.fetchSeekerSummary(data);
        commit('SET_SEEKER_SUMMARY', response.data);
        return response; // Promise を返す
      } catch (error) {
        console.error(error);
      }
    },
    // LINEメッセージ
    getLineMessages({ commit }, data) {
      return directtalk.getLineMessages(data)
      .then((d) => {
        return d.data
      })
      .catch((e) => {
        console.error('LINEメッセージ取得エラー:', e)
        return []
      })
    },
    sendLineMessage({ commit }, data) {
      return directtalk.sendLineMessage(data)
      .then((d) => {
      })
      .catch((e) => {
        console.error(e)
      })
    },
    // LINEメッセージここまで
    /**
     * 面接一覧取得
     * @param {Object} params - 検索パラメータ
     */
    async fetchInterviewList({ commit }, params) {
      try {
        const response = await directtalk.fetchInterviewList(params);
        return response.data;
      } catch (error) {
        console.error('面接一覧取得エラー:', error);
        throw error;
      }
    },
    
    /**
     * ダッシュボードメトリクス取得
     * Report.vue機能拡張用 - 2025-08-11追加
     * 
     * 取得可能なメトリクス:
     * - 今日の応募数
     * - 当月・先月の応募数
     * - 週間応募数（過去7日間の日別データ）
     * - 本日の面接予定者一覧
     * 
     * @param {Object} context - Vuexコンテキスト
     * @param {Object} data - リクエストパラメータ
     * @param {string} data.company_id - 会社ID
     * @param {string} data.metric_type - メトリクスタイプ
     * @returns {Promise} APIレスポンス
     */
    async fetchDashboardMetrics({ commit }, data) {
      try {
        const response = await directtalk.fetchDashboardMetrics(data);
        return response;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    /**
     * 媒体別レポート分析データ取得
     * @param {Object} data - リクエストパラメータ
     * @param {string} data.company_id - 会社ID
     * @param {string} data.start_date - 開始日
     * @param {string} data.end_date - 終了日
     * @returns {Promise} APIレスポンス
     */
    async fetchMediaAnalysis({ commit }, data) {
      try {
        const response = await directtalk.fetchMediaAnalysis(data);
        return response.data;
      } catch (error) {
        console.error('Media analysis fetch error:', error);
        throw error;
      }
    },
    
    async createNewSession({ commit }, data) {
      try {
        // リクエスト前のログ
        console.log('Creating new session with data:', data)
        
        const response = await directtalk.createNewSession(data)
        
        if (response.data.status === 'success') {
          // 新しいセッションIDを保存
          commit('SET_SESSION_ID', response.data.new_session_id)
          
          // 初回作成時と同じ方法でSeeker情報を設定
          // seeker.idにはsessionidを、seeker.pkにはUUID主キーを設定
          const newSeekerInfo = {
            id: response.data.sessionid,          // ★重要: sessionidをidに設定
            pk: response.data.id,                  // ★重要: UUID主キーはpkに設定
            sessionid: response.data.sessionid,
            name: response.data.seeker_name || '訪問者',
            group: data.company_id || data.group,
            count: 1,
            url: data.url || '',
            // レスポンスにseekerオブジェクトがある場合は追加情報を含める
            ...(response.data.seeker ? {
              is_new: response.data.seeker.is_new,
              subscribe_status: response.data.seeker.subscribe_status || 0
            } : {})
          }
          commit('SET_SEEKER_INFO', newSeekerInfo)
          
          // Room情報を更新
          commit('SET_ROOM_DATA', { id: response.data.room_id })
          
          // LocalStorageも更新
          if (typeof localStorage !== 'undefined') {
            localStorage.setItem('sessionid', response.data.sessionid)
          }
          
          return response.data
        } else {
          throw new Error(response.data.message || 'セッション作成に失敗しました')
        }
      } catch (error) {
        console.error('Create new session error:', error)
        
        // 401エラーの場合の特別な処理
        if (error.response && error.response.status === 401) {
          console.error('Authentication error during session creation')
          // 必要に応じて認証トークンのリフレッシュ処理を追加
        }
        
        throw error
      }
    },
    
    async reconnectWebSocket({ commit, state }, { newSessionId, roomId }) {
      // 既存のWebSocket接続をクローズ
      if (state.ws) {
        state.ws.close()
      }
      
      // 新しいWebSocket接続を確立
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
      const host = window.location.host
      const companyName = state.data.ckey
      const wsUrl = `${protocol}//${host}/ws/chat/${companyName}/${newSessionId}/widget/`
      
      commit('CONNECT_BEGIN', { uri: wsUrl, category: 'widget' })
      
      // 接続が確立されるまで少し待つ
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, 500)
      })
    },
  },
  /* *
   * Mutation
   * -> directtalk
   * */
  mutations: {
    SET_SESSION_ID(state, sessionId) {
      state.sessionId = sessionId
    },
    GET_ROOM_LIST(state, data) {
      state.isReadRoom = false
      state.isScrollLoading = true
      directtalk.getRoomListData(data).then((d) => {
        state.isReadRoom = true
        state.isScrollLoading = false
        switch (data.get_type) {
          case 'star':
            state.roomlist['star'] = d.data
            break
          case 'search':
            state.roomlist['search'] = d.data
            break
          case 'all':
            state.roomlist['all'] = d.data
            break
          case 'query':
            state.roomlist['query'] = d.data
            break
        }
      })
    },
    SET_CALENDAR(state, data) {
      state.chatData.message =
        'ご希望のお日にちをご連絡ください。\n ・' +
        data[0].start +
        '-' +
        data[0].end +
        '\n ・' +
        data[1].start +
        '-' +
        data[1].end +
        '\n ・' +
        data[2].start +
        '-' +
        data[2].end
    },
    SET_DT(state, { name, icon, id, model }) {
      state.target = name
      state.targetIcon = icon
      state.targetID = id
      state.targetModel = model
      state.selectTagNewMsg = 0
      directtalk.setSeekerData({
        sessionid: state.seeker.sessionid || state.seeker.id,
        group: state.data.ckey,
        target: name,
        count: state.seeker.count || 1
      })
    },
    UPDATE_SK(state) {
      state.updateSkFlg = true
    },
    WIDGET_RECEIVE(state, num) {
      state.selectTagNewMsg = num
    },
    MOBILE_TYPE(state) {
      var d = state.data.useragent.toLowerCase()
      if (d.indexOf('iphone') !== -1 || d.indexOf('ipad') !== -1 || d.indexOf('android') !== -1) {
        state.mobileKey === 20 ? (state.mobileKey = 0) : (state.mobileKey = 20)
      }
    },
    MESSAGE_BEGIN(state, {data, minipk}) {
      state.messageCompleted = false
      state.messageLoading = true
      let tempData = _.cloneDeep(data)
      if (tempData.files) delete tempData.files
      state.chatTalkHistory.push(tempData)
      localStorage.setItem('talkhistory_' + (minipk || state.targetID), JSON.stringify(state.chatTalkHistory))
      // チャット送信時エラーの場合は再送する
      try {
        state.ws.send(JSON.stringify(data))
        state.chatData = {
          message: '',
          name: data.name,
          url: '',
          email: data.email,
          speaker: 'my',
          icon: data.icon,
          sendToID: '',
          minibot_pk: '',
          sendToModel: '',
          scenarioNode: '',
          status: -1,
          parameter: {},
          btnIdx: 0,
          createdAt: '',
          isManager: data.isManager,
          appname: '',
          platform: '',
          refferer: '',
          useragent: '',
          count: 0,
        }
      } catch (error) {
        state.isMessageError = true
        state.ws = null
      } finally {
        state.messageLoading = false
      }
    },
    MESSAGE_TYPING(state, data) {
      state.messageCompleted = false
      state.messageLoading = true
      try {
        state.ws.send(JSON.stringify(data))
      } catch (error) {
        state.isMessageError = true
        state.ws = null
      } finally {
        state.messageLoading = false
      }
    },
    MESSAGE_FAILURE(state) {
      state.messageError = true
      state.messageLoading = false
      state.messageCompleted = false
    },
    MESSAGE_SUCCESS(state, data) {
      state.messageCompleted = true
      state.messageLoading = false
    },
    SET_ACTION(state, data) {
      state.ws.send(JSON.stringify(data))
      state.chatData = {
        message: '',
        name: data.name,
        url: '',
        email: data.email,
        speaker: 'my',
        icon: data.icon,
        sendToID: '',
        minibot_pk: '',
        sendToModel: '',
        scenarioNode: '',
        btnIdx: 0,
        createdAt: '',
        isManager: data.isManager,
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        status: -1,
        parameter: {},
        count: 0,
      }
    },
    UPD_OMIT(state, isOmit) {
      var jsonData = {}
      jsonData['sessionid'] = state.selectroom.name
      if (state.selectroom.skname != null) jsonData['name'] = state.selectroom.skname
      if (state.selectroom.email != null) jsonData['email'] = state.selectroom.email
      jsonData['is_omit'] = isOmit
      directtalk.setSeekerData(jsonData)
    },
    SET_SEEKER_FROM_INFO(state) {
      var jsonData = {}
      jsonData['sessionid'] = state.selectroom.name
      if (state.selectroom.skname != null) jsonData['name'] = state.selectroom.skname
      if (state.selectroom.email != null) jsonData['email'] = state.selectroom.email
      if (state.selectroom.isOmit != null) jsonData['is_omit'] = state.selectroom.isOmit
      directtalk.setSeekerData(jsonData)
    },
    SET_SEEKER(state) {
      directtalk.setSeekerData({
        sessionid: state.seeker.sessionid || state.seeker.id,
        appname: state.data.appname,
        platform: state.data.platform,
        width: state.data.width,
        height: state.data.height,
        color: state.data.color,
        refferer: state.data.refferer,
        useragent: state.data.useragent,
        cookies: state.data.cookies,
        count: state.data.count,
      })
    },
    SET_SUBSCRIBES_SEEKERS(state, { seekers_data, authUser, isAgent }) {
      if(authUser.length === 0 && isAgent === true) {
        state.filteredSeekers = JSON.parse(seekers_data.subscribe_seekers)
        state.filteredSeekersNum = JSON.parse(seekers_data.subscribe_seekers_num)
      } else if (authUser.length === 0 && isAgent === false){
        state.filteredSeekers = []
        state.filteredSeekersNum = 0
      } else if(authUser[0].isSeekerDisplayEnable) {
        state.filteredSeekers = JSON.parse(seekers_data.subscribe_seekers)
        state.filteredSeekersNum = JSON.parse(seekers_data.subscribe_seekers_num)
      } else {
        state.filteredSeekers = []
        state.filteredSeekersNum = 0
      }
    },
    GET_SEEKER_DATA(state, list) {
      state.companiesList = []
      for (var i in list) {
        if (list[i].sessionid) {
          directtalk
            .getSeekerData(list[i].seeker)
            .then((d) => state.companiesList.push(d.data))
            .catch(() => {})
        }
      }
    },
    SET_WDT_SEEKER(state, data) {
      directtalk.setSeekerData({
        sessionid: state.seeker.sessionid || state.seeker.id,
        group: state.data.ckey,
        widget_status: data,
        count: state.seeker.count || 1
      })
    },
    SET_SK_AT_HS(state, { target, action, url, element }) {
      directtalk
        .createSeekerActionHistoryData({
          sessionid: state.seeker.id,
          group: state.data.ckey,
          target: target,
          action_name: action,
          url: url,
          element: element,
        })
        .then(() => {})
        .catch(() => {})
    },
    GET_MESSAGE(state, { name, pages }) {
      state.isChatLogs = true
      state.chatLogsLoading = true
      var uid = ''
      var cid = ''
      var type = ''
      if (name === 'seeker') {
        uid = state.seeker.id
        cid = state.data.ckey
        type = 'seeker'
      } else {
        uid = state.selectroom.name
        cid = state.selectroom.group
        type = 'manager'
      }
      directtalk
        .getMessageData(uid, cid, type, pages)
        .then((d) => {
          // ロードメッセージが初回以外かつメッセージの読み込みがこれ以上ないとき
          if (d.data.length === state.chatLogs.length && state.messagePages > 1) {
            state.isGetMessageMax = true
            alert('最後のメッセージまで読み込み終わりました。')
          } else {
            var logs = []
            for (var chat in d.data) {
              var jsonData = {}
              jsonData['message'] = d.data[chat].message
              jsonData['name'] =
                d.data[chat].speakername === 'seeker' && name === 'seeker'
                  ? 'あなた'
                  : d.data[chat].name
              jsonData['email'] = d.data[chat].email
              jsonData['speaker'] = d.data[chat].speakername === name ? 'my' : 'other'
              jsonData['icon'] = d.data[chat].icon
              var s =
                d.data[chat].created_at.replace(/-/g, '/').substring(0, 19) +
                  d.data[chat].created_at.substring(26, 29)
              jsonData['createdAt'] = new Date(s)
              jsonData['createdAtOther'] = new Date(d.data[chat].created_at)
              jsonData['isManager'] = d.data[chat].speakername === 'seeker' ? '0' : '1'
              jsonData['isBot'] = d.data[chat].isBot
              jsonData['files'] = d.data[chat].files
              jsonData['filename'] = d.data[chat].filename
              jsonData['parameter'] = d.data[chat].parameter
              jsonData['status'] = d.data[chat].status
              jsonData['id'] = d.data[chat].id
              
              // bot_idを追加（バックエンドから送られてくる場合）
              if (d.data[chat].bot_id) {
                jsonData['bot_id'] = d.data[chat].bot_id
              }
              
              logs.push(jsonData)
            }
            state.chatLogs = logs
            state.isGetMessageMax = false
          }
          state.chatLogsLoading = false
        })
        .catch((e) => {
          console.error('getMessageData error:', e)
          state.chatLogsLoading = false
        })
      // 読み込みメッセージのカウントアップ
      state.messagePages = pages
    },
    SET_CHAT_LOGS_DEMO(state, chatLogsDemo) {
      state.chatLogs.push(chatLogsDemo)
      state.chatTalkHistory.push(chatLogsDemo)
    },
    IMP_MESSAGE(state, data) {
      directtalk
        .importMessageData(data)
        .then((d) => {
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
        })
    },
    GET_ROOM_DEMO(state, cid) {
      directtalk.getRoomDemoData(cid).then((d) => {
        state.widgetDataDemo = d.data
      })
    },
    GET_ROOM(state) {
      var uid = state.seeker.id
      var cid = state.data.ckey
      if (uid != null) {
        directtalk
          .getRoomData(uid, cid, {url: state.data.url})
          .then((d) => {
            state.widgetData.roomPK = d.data.room_pk
            state.widgetData.name = d.data.seeker_name
            state.widgetData.companyPK = d.data.company_pk
            state.widgetData.companyName = d.data.company_name
            state.widgetData.companyEmail = d.data.company_email
            state.widgetData.action = d.data.action
            state.widgetData.count = d.data.manager
            state.widgetData.recommendBot = d.data.recommend_bot
            state.widgetData.recommendBotCount = d.data.recommend_bot_count
            state.widgetData.story = JSON.parse(d.data.story)
            state.widgetData.recruit = d.data.recruit
            state.widgetData.custom = d.data.custom
            state.widgetData.homepages = JSON.parse(d.data.homepages)
            state.widgetData.bots = d.data.bots
            state.widgetData.tags = d.data.tags
            state.widgetData.todayIsHoliday = d.data.today_is_holiday
            state.messageHistory = d.data.messages
            state.widgetData.connectCount = d.data.connectCount
            state.widgetData.readTime = d.data.readTime
            state.widgetData.newMsgCount = d.data.newMsgCount
            state.widgetData.newMsgCountBot = d.data.newMsgCountBot
            state.widgetData.latest_author = d.data.latest_author
            state.widgetData.welcomeMsg = d.data.welcomeMsg
            state.widgetData.welcomeMsgDetail = d.data.welcomeMsgDetail
            state.widgetData.welcomeMsgTitle = d.data.welcomeMsgTitle
            state.widgetData.isAuto = d.data.isAuto
            state.widgetData.subscribe_is_name = d.data.subscribe_is_name
            state.widgetData.subscribe_is_email = d.data.subscribe_is_email
            state.widgetData.subscribe_is_tel = d.data.subscribe_is_tel
            state.widgetData.subscribe_is_name_phonetic = d.data.subscribe_is_name_phonetic
            state.widgetData.subscribe_is_job_offer_no = d.data.subscribe_is_job_offer_no
            state.widgetData.subscribe_is_sex = d.data.subscribe_is_sex
            state.widgetData.subscribe_is_birth = d.data.subscribe_is_birth
            state.widgetData.subscribe_is_address = d.data.subscribe_is_address
            state.widgetData.subscribe_is_message = d.data.subscribe_is_message
            state.widgetData.subscribe_list_message = d.data.subscribe_list_message
            state.widgetData.subscribe_required_name = d.data.subscribe_required_name
            state.widgetData.subscribe_required_email = d.data.subscribe_required_email
            state.widgetData.subscribe_required_tel = d.data.subscribe_required_tel
            state.widgetData.subscribe_required_name_phonetic =
              d.data.subscribe_required_name_phonetic
            state.widgetData.subscribe_required_sex = d.data.subscribe_required_sex
            state.widgetData.subscribe_required_birth = d.data.subscribe_required_birth
            state.widgetData.subscribe_required_address = d.data.subscribe_required_address
            state.widgetData.subscribe_required_message = d.data.subscribe_required_message
            state.widgetData.scout_flg = d.data.scout_flg
            state.widgetData.scout_message = d.data.scout_message
            state.widgetData.scout_mail_title = d.data.scout_mail_title
            state.widgetData.scout_mail_message = d.data.scout_mail_message
            state.widgetData.scout_mail_flg = d.data.scout_mail_flg
            state.widgetData.autoScout = d.data.autoScout
            if (state.widgetData.users.length !== d.data.user_info.length) {
              state.widgetData.users = d.data.user_info.sort(function (a, b) {
                if (a.latest_author > b.latest_author) return -1
                if (a.latest_author < b.latest_author) return 1
                if (a.isConnect > b.isConnect) return -1
                if (a.isConnect < b.isConnect) return 1
                return 0
              })
            }
            state.color = d.data.color
            state.power = d.data.power
            state.isLoaded = true
          })
          .catch((e) => {
            state.isLoaded = true
            // console.error(e)
          })
      }
    },
    GET_ROOM_TEMP(state) {
      var cid = state.data.ckey
      directtalk.getRoomTempData(cid).then((d) => {
        state.widgetData.companyName = d.data.company_name
        state.widgetData.bots = []
        state.widgetData.tags = []
        for (var i in d.data.bot_info) {
          var urlAryT = d.data.bot_info[i].target_url.split('|')
          for (var j in urlAryT) {
            // alert(urlAryT[j])
            // 空白は無視
            if (urlAryT[j] === '') continue
            if (
              urlAryT[j] === state.data.url.split('?')[0] ||
              state.data.url === urlAryT[j].replace(/\/$/, '')
            ) {
              state.widgetData.tags = state.widgetData.tags.concat(d.data.bot_info[i].tag)
              state.widgetData.bots.push(d.data.bot_info[i])
              if (state.widgetData.recommendBotCount < d.data.bot_info[i].message_count) {
                state.widgetData.recommendBotCount = d.data.bot_info[i].message_count
                state.widgetData.recommendBot = d.data.bot_info[i].bot_id
              }
            }
          }
        }
        // タグの重複削除
        state.widgetData.tags = Array.from(new Set(state.widgetData.tags))
        if (state.widgetData.bots.length > 0) {
          state.widgetData.bots = state.widgetData.bots.sort(function (a, b) {
            if (a.message_count > b.message_count) return -1
            if (a.message_count < b.message_count) return 1
            return 0
          })
        }
        state.widgetData.welcomeMsg = d.data.welcomeMsg
        state.widgetData.welcomeMsgDetail = d.data.welcomeMsgDetail
        state.widgetData.welcomeMsgTitle = d.data.welcomeMsgTitle
        state.widgetData.isAuto = d.data.isAuto
        state.color = d.data.color
        state.power = d.data.power
      })
    },
    MORE_ROOM(state) {
      state.roomlistScroll++
      state.isScroll = true
    },
    SET_JSON(state, data) {
      state.own = data.url
      state.chatData.isManager = '0'
      state.seeker.count = Number(data.count) + 1
      directtalk
        .createSeekerData({
          name: 'seeker_default',
          sessionid: data.sessionid,
          group: data.ckey,
          appname: data.appname,
          platform: data.platform,
          width: data.width,
          height: data.height,
          color: data.color,
          useragent: data.useragent,
          url: data.url,
          isTimeLine: data.isTimeLine === true,
        })
        .then((d) => {
          if (d.data.status != null) {
            directtalk.setSeekerData({
              sessionid: data.sessionid,
              appname: data.appname,
              platform: data.platform,
              width: data.width,
              height: data.height,
              color: data.color,
              refferer: data.refferer,
              useragent: data.useragent,
              cookies: data.cookies,
              count: state.seeker.count,
              url: data.url,
            })
            state.seeker.id = data.sessionid
            state.seeker.pk = d.data.id
            state.seeker.scout = JSON.parse(d.data.scout)
            state.seeker.story = d.data.story ? JSON.parse(d.data.story) : null
            state.seeker.chatbot = d.data.chatbot ? JSON.parse(d.data.chatbot) : null
          } else if (data.isTimeLine) {
            state.seeker.id = d.data
          } else {
            state.wdt = 0
            state.seeker.id = d.data.sessionid
            state.seeker.pk = d.data.id
          }
          if (!data.isTimeLine) {
            directtalk
              .createSeekerHistoryData({
                sessionid: state.seeker.id,
                group: data.ckey,
                appname: data.appname,
                platform: data.platform,
                width: data.width,
                height: data.height,
                color: data.color,
                referrer: data.referrer,
                useragent: data.useragent,
                url: data.url,
              })
              .then((d) => {
                const tempSeekerTagHistory = {
                  seeker: state.seeker.pk,
                  action_name: 'visit',
                  url: data.url,
                  tag: state.widgetData.tags,
                }
                if (state.seeker.pk) {
                  directtalk.createSeekerTagHistory(tempSeekerTagHistory)
                  state.seekerSync = JSON.parse(d.data)
                }
              })
          }
          state.data = {
            id: state.seeker.id,
            url: data.url,
            appname: data.appname,
            platform: data.platform,
            width: data.width,
            height: data.height,
            color: data.color,
            referrer: data.referrer,
            useragent: data.useragent,
            ckey: data.ckey,
            cookies: data.cookies,
            count: state.seeker.count,
          }
        })
    },
    SET_MANAGER(state, uri) {
      state.own = uri
      state.chatData.url = uri
      state.chatData.isManager = '1'
    },
    SET_ISREAD(state, speaker) {
      var uid = ''
      var cid = ''
      if (speaker === 'seeker') {
        uid = state.seeker.id
        cid = state.data.ckey
      } else {
        uid = state.selectroom.name
        cid = state.selectroom.group
      }
      directtalk
        .setIsRead(uid, cid, speaker)
        .then((d) => {
          // 訪問者か管理者かでstateを分ける
          if (speaker === 'seeker') {
            state.widgetData.newMsgCountBot = 0
            state.widgetData.newMsgCount = 0
          } else {
            for (let index in state.roomlist.active)
              if (state.roomlist.active[index].name === state.selectroom.name)
                state.roomlist.active[index].newMessage = 0
            for (let index in state.roomlist.search)
              if (state.roomlist.search[index].name === state.selectroom.name)
                state.roomlist.search[index].newMessage = 0
            for (let index in state.roomlist.all)
              if (state.roomlist.all[index].name === state.selectroom.name)
                state.roomlist.all[index].newMessage = 0
          }
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
        })
    },
    ADD_COUNT(state, { uid, name, type }) {
      var sid = state.seeker.id
      var cid = state.data.ckey
      var data = {
        session_id: state.seeker.id,
        company_hash: state.data.ckey,
        user_hash: uid,
        react_name: name,
        react_type: type,
      }
      directtalk
        .addCount(uid, cid, sid, data)
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
        })
    },
    SEEKER_COUNT(state, type) {
      directtalk
        .seekerCount(type)
        .then((d) => {
          state.isloading = false
          state.isSeekerCount = true
          state.dashboardKPI.seekerNewCount = d.data.seeker_new_count
          state.dashboardKPI.seekerOldCount = d.data.seeker_old_count
          state.dashboardKPI.seekerDauCount = d.data.seeker_dau_count
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
        })
    },
    SELECT_ROOM(state, data) {
      state.selectroom = data
      state.chatLogs = []
      state.messagePages = 1
      for (let i in state.roomlist.active) {
        if (data.name === state.roomlist.active[i].name) state.roomlist.active[i].newMessage = 0
      }
      for (let i in state.roomlist.search) {
        if (data.name === state.roomlist.search[i].name) state.roomlist.search[i].newMessage = 0
      }
      for (let i in state.roomlist.all) {
        if (data.name === state.roomlist.all[i].name) state.roomlist.all[i].newMessage = 0
      }
    },
    GET_URL_LIST(state, data) {
      directtalk.getUrlList(data).then((d) => {
        data.url = d.data
      })
    },
    SET_STAR(state, { data, index }) {
      directtalk.setStar(data).then(() => {
        state.roomlist.all[index].star = data.star
      })
    },
    SELECT_ACTION(state, data) {
      state.wslist.send(
        JSON.stringify({
          name: data.name,
          group: data.group,
          action: data.action,
          talk: data.talk,
          scenario: data.scenario,
        })
      )
    },
    GET_READ_COUNT(state) {
      var cid = state.data.ckey
      directtalk
        .getReadCount(cid)
        .then((d) => {
          state.alreadyCount = d.data.count
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
        })
    },
    /* *
     * チャットルームへの接続
     * @chatData
     * */
    CONNECT_BEGIN(state, { uri, category }) {
      try {
        if (state.ws == null) {
          state.isReconnect = false
          state.ws = new WebSocket(uri + category + '/')
        }
      } catch (error) {
        state.ws = null
        state.isReconnect = true
      } finally {
      }
      state.ws.onerror = (e) => {
        state.ws.close()
        state.ws = null
        state.typing = 'end_typing@'
      }
      state.ws.onopen = (e) => {
        state.isConnectRoom = true
      }
      state.ws.onclose = (e) => {
        state.isConnectRoom = false
        state.ws = null
        state.typing = 'end_typing@'
      }
      state.ws.onmessage = (e) => {
        const data = JSON.parse(e.data)

        if (
          data.message.indexOf('start_typing') === -1 &&
          data.message.indexOf('end_typing') === -1
        ) {
          var insertData = {
            message: '',
            name: '',
            url: '',
            email: '',
            speaker: 'my',
            icon: '',
            sendToID: '',
            minibot_pk: '',
            sendToModel: '',
            scenarioNode: '',
            status: -1,
            parameter: {},
            btnIdx: 0,
            createdAt: '',
            isManager: '0',
            appname: '',
            platform: '',
            refferer: '',
            useragent: '',
            count: 0,
            files: '',
            filename: '',
          }
          // 訪問者側と管理ツール側の振り分け
          if (data.isManager === '0') {
            insertData.name = data.url !== state.own ? data.name : 'あなた'
            insertData.appname = data.appname
            insertData.platform = data.platform
            insertData.refferer = data.refferer
            insertData.useragent = data.useragent
            insertData.count = data.count
            state.selectroom.readTime = new Date()
          } else {
            insertData.name = data.name
            if (data.name === null)
            insertData.name = ''
          }
          insertData.sendToID = data.sendToID
          insertData.minibot_pk = data.minibot_pk
          insertData.sendToModel = data.sendToModel
          insertData.scenarioNode = data.scenarioNode
          insertData.btnIdx = data.btnIdx
          insertData.icon = data.icon
          insertData.status = data.status
          insertData.parameter = data.parameter
          insertData.message = data.message
          insertData.email = data.email
          insertData.createdAt = new Date(data.createdAt)
          insertData.isManager = data.isManager
          insertData.files = data.files ? data.files : ''
          insertData.filename = data.filename ? data.filename : ''
          insertData.speaker = data.url !== state.own ? 'other' : data.speaker

          // Botの場合の振り分け
          if (data.url !== state.own && data.isBot) {
            insertData.speaker = 'my'
          } else if (data.url !== state.own && data.isBot) {
            insertData.speaker = 'other'
          }
          insertData.isBot = data.isBot
          state.data.count = data.count
          state.chatLogs.push(insertData)
          state.typing = ''
        } else {
          state.typing = data.message
        }
      }
    },
    CONNECT_END(state) {
      if (state.ws != null) {
        state.ws.close()
        state.typing = 'end_typing@'
      }
    },
    /* *
     * チャットルーム一覧への接続
     * setIntervalによる常時呼び出し
     * */
    CONNECT_LIST(state, uri) {
      state.wslist = new WebSocket(uri)
      state.wslist.onerror = (e) => {
        state.isConnectList = false
        state.wslist.close()
      }
      state.wslist.onclose = (e) => {
        state.isConnectList = false
      }
      state.wslist.onopen = (e) => {
        state.isConnectList = true
        state.wslist.send(state.roomlistScroll)
      }
      state.wslist.onmessage = (e) => {
        const data = JSON.parse(e.data)
        state.roomlist['active'] = data.list
        state.roomcount = Object.keys(data.list).length
        var idx = -1
        state.roomlist.active.find(function (item, i) {
          if (item.name === state.selectroom.name) {
            idx = i
            return i
          }
        })
        if (idx !== -1) {
          state.selectroom.url = state.roomlist.active[idx].url
          state.selectroom.readTime = state.roomlist.active[idx].readTime
        }
        for (var index in state.roomlist.active) {
          idx = -1
          state.roomlist.star.find(function (item, i) {
            if (item.name === state.roomlist.active[index].name) {
              idx = i
              return i
            }
          })
          if (idx !== -1) state.roomlist.star[idx] = state.roomlist.active[index]
          idx = -1
          state.roomlist.search.find(function (item, i) {
            if (item.name === state.roomlist.active[index].name) {
              idx = i
              return i
            }
          })
          if (idx === -1) state.roomlist.search.unshift(state.roomlist.active[index])
          else state.roomlist.search.splice(idx, 1, state.roomlist.active[index])
        }
      }
    },
    GET_GRAPH_DATA(state, typeData) {
      state.graphData = []
      for (let count in state.graphCount) {
        state.graphCount[count] = []
      }
      directtalk.getGraphData(typeData.minDay, typeData.maxDay).then((d) => {
        state.isLoading = false
        state.graphData = d.data
        // URL別
        if (typeData.clickUrl) {
          state.isLoading = true
          state.isUrl = typeData.clickUrl
          state.urlList = []
          state.urlList.push(typeData.clickUrl)
          state.isLoading = false
          // URL全表示
        } else {
          let allUrl = []
          for (let graphData of state.graphData) {
            for (let _new of graphData.new) {
              allUrl.push(_new.url)
            }
          }
          state.urlList = allUrl.filter(function (x, i, self) {
            return self.indexOf(x) === i
          })
        }
        state.displayUrl = state.urlList.filter((data, index) => {
          if (index >= (typeData.pages - 1) * 5 && index <= typeData.pages * 5 - 1) {
            return data
          }
        })
        state.graphData.sort(function (a, b) {
          if (a.date > b.date) return 1
          else if (a.date < b.date) return -1
          return 0
        })
        if (typeData.type === 'day') {
          let uri = location.href
          let pattern = 'dashboard?uri='
          for (let data of state.graphData) {
            state.labels.push(moment(data.date).format('MM/DD (ddd)'))
            if (~uri.indexOf(pattern)) {
              let reseeker_count = 0
              for (let reseeker of data.reseeker) {
                if (reseeker.url === typeData.clickUrl) {
                  reseeker_count++
                }
              }
              state.graphCount.reseekerCount.push(reseeker_count)
              let new_count = 0
              for (let n of data.new) {
                if (n.url === typeData.clickUrl) {
                  new_count++
                }
              }
              state.graphCount.newCount.push(new_count)
              state.graphCount.dauCount.push(
                reseeker_count - new_count > 0 ? reseeker_count - new_count : 0
              )
              let icon_count = 0
              for (let icon of data.icon) {
                if (icon.url === typeData.clickUrl) {
                  icon_count++
                }
              }
              state.graphCount.iconCount.push(icon_count)
              let already_read_count = 0
              for (let already_read of data.already_read) {
                if (already_read.url === typeData.already_read) {
                  already_read_count++
                }
              }
              state.graphCount.alreadyReadCount.push(already_read_count)
              let reply_count = 0
              for (let reply of data.reply) {
                if (reply.url === typeData.reply) {
                  reply_count++
                }
              }
              state.graphCount.replyCount.push(reply_count)
              let subscribe_count = 0
              for (let subscribe of data.subscribe) {
                if (subscribe.url === typeData.subscribe) {
                  subscribe_count++
                }
              }
              state.graphCount.subscribeCount.push(subscribe_count)
              let user_agent_count = 0
              for (let user_agent of data.user_agent) {
                if (user_agent.url === typeData.user_agent) {
                  user_agent_count++
                }
              }
              state.graphCount.useragentCount.push(user_agent_count)
            } else {
              state.graphCount.dauCount.push(
                data.new.length > data.reseeker.length ? data.new.length : data.reseeker.length
              )
              state.graphCount.newCount.push(data.new.length)
              state.graphCount.reseekerCount.push(
                data.reseeker.length - data.new.length > 0
                  ? data.reseeker.length - data.new.length
                  : 0
              )
              state.graphCount.iconCount.push(data.icon.length)
              state.graphCount.alreadyReadCount.push(data.already_read.length)
              state.graphCount.replyCount.push(data.reply.length)
              state.graphCount.subscribeCount.push(data.subscribe.length)
              state.graphCount.useragentCount.push(data.user_agent.length)
            }
          }
        } else if (typeData.type === 'week') {
          let uri = location.href
          let pattern = 'dashboard?uri='
          for (let i = 0; i < 35; i += 7) {
            let data = state.graphData.slice(i, i + 7)
            state.labels.push(format(data))
            let count = {
              dau: 0,
              new: 0,
              reseeker: 0,
              icon: 0,
              useragent: 0,
              alreadyRead: 0,
              reply: 0,
              subscribe: 0,
            }
            for (let value of data) {
              if (~uri.indexOf(pattern)) {
                for (let v of value.reseeker) {
                  if (typeData.clickUrl === v.url) {
                    count.reseeker++
                  }
                }
                for (let v of value.new) {
                  if (typeData.clickUrl === v.url) {
                    count.new++
                  }
                }
                count.dau = count.new > count.reseeker ? count.new : count.reseeker
                for (let v of value.icon) {
                  if (typeData.clickUrl === v.url) {
                    count.icon++
                  }
                }
                for (let v of value.already_read) {
                  if (typeData.clickUrl === v.url) {
                    count.alreadyRead++
                  }
                }
                for (let v of value.reply) {
                  if (typeData.clickUrl === v.url) {
                    count.reply++
                  }
                }
                for (let v of value.subscribe) {
                  if (typeData.clickUrl === v.url) {
                    count.subscribe++
                  }
                }
                for (let v of value.user_agent) {
                  if (typeData.clickUrl === v.url) {
                    count.useragent++
                  }
                }
              } else {
                count.dau +=
                  value.new.length > value.reseeker.length
                    ? value.new.length
                    : value.reseeker.length
                count.new += value.new.length
                count.reseeker +=
                  value.reseeker.length - value.new.length > 0
                    ? value.reseeker.length - value.new.length
                    : 0
                count.icon += value.icon.length
                count.alreadyRead += value.already_read.length
                count.reply += value.reply.length
                count.subscribe += value.subscribe.length
                count.useragent += value.user_agent.length
              }
            }
            state.graphCount.dauCount.push(count.dau)
            state.graphCount.newCount.push(count.new)
            state.graphCount.reseekerCount.push(count.reseeker)
            state.graphCount.iconCount.push(count.icon)
            state.graphCount.alreadyReadCount.push(count.alreadyRead)
            state.graphCount.replyCount.push(count.reply)
            state.graphCount.subscribeCount.push(count.subscribe)
            state.graphCount.useragentCount.push(count.useragent)
          }
        } else if (typeData.type === 'biweek') {
          let uri = location.href
          let pattern = 'dashboard?uri='
          for (let i = 0; i < 70; i += 14) {
            let data = state.graphData.slice(i, i + 14)
            state.labels.push(format(data))
            let count = {
              dau: 0,
              new: 0,
              reseeker: 0,
              icon: 0,
              useragent: 0,
              alreadyRead: 0,
              reply: 0,
              subscribe: 0,
            }
            for (let value of data) {
              if (~uri.indexOf(pattern)) {
                for (let v of value.reseeker) {
                  if (typeData.clickUrl === v.url) {
                    count.reseeker++
                  }
                }
                for (let v of value.new) {
                  if (typeData.clickUrl === v.url) {
                    count.new++
                  }
                }
                count.dau = count.new > count.reseeker ? count.new : count.reseeker
                for (let v of value.icon) {
                  if (typeData.clickUrl === v.url) {
                    count.icon++
                  }
                }
                for (let v of value.already_read) {
                  if (typeData.clickUrl === v.url) {
                    count.alreadyRead++
                  }
                }
                for (let v of value.reply) {
                  if (typeData.clickUrl === v.url) {
                    count.reply++
                  }
                }
                for (let v of value.subscribe) {
                  if (typeData.clickUrl === v.url) {
                    count.subscribe++
                  }
                }
                for (let v of value.user_agent) {
                  if (typeData.clickUrl === v.url) {
                    count.useragent++
                  }
                }
              } else {
                count.dau +=
                  value.new.length > value.reseeker.length
                    ? value.new.length
                    : value.reseeker.length
                count.new += value.new.length
                count.reseeker +=
                  value.reseeker.length - value.new.length > 0
                    ? value.reseeker.length - value.new.length
                    : 0
                count.icon += value.icon.length
                count.alreadyRead += value.already_read.length
                count.reply += value.reply.length
                count.subscribe += value.subscribe.length
                count.useragent += value.user_agent.length
              }
            }
            state.graphCount.dauCount.push(count.dau)
            state.graphCount.newCount.push(count.new)
            state.graphCount.reseekerCount.push(count.reseeker)
            state.graphCount.iconCount.push(count.icon)
            state.graphCount.useragentCount.push(count.useragent)
            state.graphCount.alreadyReadCount.push(count.alreadyRead)
            state.graphCount.replyCount.push(count.reply)
            state.graphCount.subscribeCount.push(count.subscribe)
          }
        } else if (typeData.type === 'month') {
          let day = typeData.minDay
          for (let m = 0; m < 6; m++) {
            let onemonth = []
            for (let data of state.graphData) {
              if (
                moment(day).get('month') === moment(data.date).get('month') &&
                moment(day).get('year') === moment(data.date).get('year')
              ) {
                onemonth.push(data)
              }
            }
            let uri = location.href
            let pattern = 'dashboard?uri='
            state.labels.push(moment(onemonth[0].date).format('YYYY-MM'))
            day = moment(day).add(1, 'month')
            let count = {
              dau: 0,
              new: 0,
              reseeker: 0,
              icon: 0,
              useragent: 0,
              alreadyRead: 0,
              reply: 0,
              subscribe: 0,
            }
            for (let value of onemonth) {
              if (~uri.indexOf(pattern)) {
                for (let v of value.reseeker) {
                  if (typeData.clickUrl === v.url) {
                    count.reseeker++
                  }
                }
                for (let v of value.new) {
                  if (typeData.clickUrl === v.url) {
                    count.new++
                  }
                }
                count.dau = count.new > count.reseeker ? count.new : count.reseeker
                for (let v of value.icon) {
                  if (typeData.clickUrl === v.url) {
                    count.icon++
                  }
                }
                for (let v of value.already_read) {
                  if (typeData.clickUrl === v.url) {
                    count.alreadyRead++
                  }
                }
                for (let v of value.reply) {
                  if (typeData.clickUrl === v.url) {
                    count.reply++
                  }
                }
                for (let v of value.subscribe) {
                  if (typeData.clickUrl === v.url) {
                    count.subscribe++
                  }
                }
                for (let v of value.user_agent) {
                  if (typeData.clickUrl === v.url) {
                    count.useragent++
                  }
                }
              } else {
                count.dau +=
                  value.new.length > value.reseeker.length
                    ? value.new.length
                    : value.reseeker.length
                count.new += value.new.length
                count.reseeker +=
                  value.reseeker.length - value.new.length > 0
                    ? value.reseeker.length - value.new.length
                    : 0
                count.icon += value.icon.length
                count.alreadyRead += value.already_read.length
                count.reply += value.reply.length
                count.subscribe += value.subscribe.length
                count.useragent += value.user_agent.length
              }
            }
            state.graphCount.dauCount.push(count.dau)
            state.graphCount.newCount.push(count.new)
            state.graphCount.reseekerCount.push(count.reseeker)
            state.graphCount.iconCount.push(count.icon)
            state.graphCount.useragentCount.push(count.useragent)
            state.graphCount.alreadyReadCount.push(count.alreadyRead)
            state.graphCount.replyCount.push(count.reply)
            state.graphCount.subscribeCount.push(count.subscribe)
          }
        }
        state.lineDatacollection = {
          labels: state.labels,
          datasets: [
            {
              label: '訪問者計',
              backgroundColor: '#d81b60',
              borderColor: '#d81b60',
              pointRadius: 2,
              data: state.graphCount.dauCount,
              fill: false,
              hidden: false,
            },
            {
              label: '新規',
              backgroundColor: '#5E35B1',
              borderColor: '#5E35B1',
              pointRadius: 2,
              data: state.graphCount.newCount,
              fill: false,
              hidden: true,
            },
            {
              label: '再来訪者',
              backgroundColor: '#039BE5',
              borderColor: '#039BE5',
              pointRadius: 2,
              data: state.graphCount.reseekerCount,
              fill: false,
              hidden: true,
            },
            {
              label: 'ロボクリック',
              backgroundColor: '#00897B',
              borderColor: '#00897B',
              pointRadius: 2,
              data: state.graphCount.iconCount,
              fill: false,
              hidden: true,
            },
            {
              label: 'ロボ既読',
              backgroundColor: '#7CB342',
              borderColor: '#7CB342',
              pointRadius: 2,
              data: state.graphCount.alreadyReadCount,
              fill: false,
              hidden: true,
            },
            {
              label: 'ロボ返信',
              backgroundColor: '#FDD835',
              borderColor: '#FDD835',
              pointRadius: 2,
              data: state.graphCount.replyCount,
              fill: false,
              hidden: true,
            },
            {
              label: '応募者',
              backgroundColor: '#FB8C00',
              borderColor: '#FB8C00',
              pointRadius: 2,
              data: state.graphCount.subscribeCount,
              fill: false,
              hidden: true,
            },
            {
              label: 'スマホユーザー',
              backgroundColor: '#6D4C41',
              borderColor: '#6D4C41',
              pointRadius: 2,
              data: state.graphCount.useragentCount,
              fill: false,
              hidden: true,
            },
          ],
        }
        let total = state.graphCount.dauCount.reduce(function (total, data) {
          return total + data
        })
        if (total < 0) {
          total = 0
        }
        state.sumCount.dau = total
        total = state.graphCount.newCount.reduce(function (total, data) {
          return total + data
        })
        if (total < 0) {
          total = 0
        }
        state.sumCount.new = total
        total = state.graphCount.reseekerCount.reduce(function (total, data) {
          return total + data
        })
        if (total < 0) {
          total = 0
        }
        state.sumCount.reseeker = total
        total = state.graphCount.iconCount.reduce(function (total, data) {
          return total + data
        })
        if (total < 0) {
          total = 0
        }
        state.sumCount.icon = total
        total = state.graphCount.alreadyReadCount.reduce(function (total, data) {
          return total + data
        })
        if (total < 0) {
          total = 0
        }
        state.sumCount.alreadyRead = total
        total = state.graphCount.replyCount.reduce(function (total, data) {
          return total + data
        })
        if (total < 0) {
          total = 0
        }
        state.sumCount.reply = total
        total = state.graphCount.subscribeCount.reduce(function (total, data) {
          return total + data
        })
        if (total < 0) {
          total = 0
        }
        state.sumCount.subscribe = total
        total = state.graphCount.useragentCount.reduce(function (total, data) {
          return total + data
        })
        if (total < 0) {
          total = 0
        }
        state.sumCount.useragent = total
      })
    },
    TOGGLE_GRAPH_LINE(state, lineName) {
      var lineNameArr = [
        'dau',
        'new',
        'reseeker',
        'icon',
        'alreadyRead',
        'reply',
        'subscribe',
        'useragent',
      ]
      for (var i = 0; i < lineNameArr.length; i++) {
        if (lineName === lineNameArr[i]) {
          state.lineDatacollection.datasets[i].hidden = !state.lineDatacollection.datasets[i].hidden
        }
      }
      state.toggleState = !state.toggleState
    },
    OPEN_LOADING(state) {
      state.labels = []
      state.newCount = []
      state.reseekerCount = []
      state.iconCount = []
      state.useragentCount = []
      state.alreadyReadCount = []
      state.replyCount = []
      state.subscribeCount = []
      state.isLoading = true
    },
    RESUME_CREATE(state, data) {
      state.resume.push(data)
      state.pdfFile = data
    },
    RESUME_CREATE_DEMO(state, data) {
      state.resume.push(data)
      state.pdfFile = data
    },
    UPDATE_RESUME(state, data) {
      resume
        .updateResume(data)
        .then((d) => {
          state.resume = [data]
          alert('修正が完了しました。')
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
          alert('エラーが発生しました。')
        })
    },
    SET_MANAGE(state, data) {
      directtalk.setManage(data).then((d) => {
        state.manage = d.data.manage
      })
    },
    OPEN_VIDEO_INTERVIEW(state, selectroom) {
      state.selectroom = selectroom
      state.isVideoInterview = true
    },
    SCROLL_TALK(state, data) {
      state.scrolltalk = data
    },
    CLOSE_VIDEO_INTERVIEW(state) {
      state.isVideoInterview = false
    },
    GET_LM(state, { data, name, pages }) {
      state.isChatLogs = true
      state.chatLogsLoading = true
      var uid = ''
      var cid = ''
      var type = ''

      if (name === 'seeker') {
        type = 'seeker'
      } else {
        type = 'manager'
      }
      for (let d of data) {
        uid = uid + ',' + d.sessionid
      }
      for (let d of data) {
        cid = cid + ',' + d.ckey
      }
      directtalk
        .getLastMessageData(uid, cid, type, pages)
        .then((d) => {
          state.lastmessage.push(d.data)
          let logs = []
          for (let chat in d.data) {
            let jsonData = {}
            jsonData['message'] = d.data[chat].message
            jsonData['name'] =
              d.data[chat].speakername === 'seeker' && name === 'seeker'
                ? 'あなた'
                : d.data[chat].name
            jsonData['email'] = d.data[chat].email
            jsonData['speaker'] = d.data[chat].speakername === name ? 'my' : 'other'
            jsonData['icon'] = d.data[chat].icon
            let s =
              d.data[chat].created_at.replace(/-/g, '/').substring(0, 17) +
              d.data[chat].created_at.substring(25, 29)
            jsonData['createdAt'] = new Date(s)
            jsonData['createA'] = d.data[chat].created_at
            let ss =
              d.data[chat].created_at.substring(0, 4) +
              '年' +
              d.data[chat].created_at.substring(5, 7) +
              '月' +
              d.data[chat].created_at.substring(8, 10) +
              '日'
            jsonData['createB'] = ss
            let sss =
              d.data[chat].created_at.substring(0, 4) +
              d.data[chat].created_at.substring(5, 7) +
              d.data[chat].created_at.substring(8, 10) +
              d.data[chat].created_at.substring(11, 13) +
              d.data[chat].created_at.substring(14, 16) +
              d.data[chat].created_at.substring(17, 19)
            jsonData['createC'] = sss
            jsonData['isManager'] = d.data[chat].speakername === 'seeker' ? '0' : '1'
            jsonData['isBot'] = d.data[chat].isBot
            jsonData['files'] = d.data[chat].files
            jsonData['filename'] = d.data[chat].filename
            jsonData['testid'] = d.data[chat].testid
            logs.push(jsonData)
          }
          state.chatLogs2 = logs
          state.chatLogsLoading = false
        })
        .catch((e) => {
        })
      // 読み込みメッセージのカウントアップ
      state.messagePages = pages
    },
    GET_RE_LM(state, { data, name, pages }) {
      state.isChatLogs = true
      state.chatLogsLoading = true
      var uid = ''
      var cid = ''
      var type = ''

      if (name === 'seeker') {
        type = 'seeker'
      } else {
        type = 'manager'
      }
      for (var session in data) {
        uid = uid + ',' + data[session].sessionid
      }
      for (var aaa in data) {
        cid = cid + ',' + data[aaa].ckey
      }
      directtalk
        .getLastMessageReadData(uid, cid, type, pages)
        .then((d) => {
          state.lastreadmessage.push(d.data)
          var logs = []
          for (var chat in d.data) {
            var jsonData = {}
            jsonData['created_time'] = d.data[chat].created_time
            jsonData['ended_time'] = d.data[chat].ended_time
            jsonData['uid'] = uid
            jsonData['cid'] = cid
            var sss =
              d.data[chat].created_time.substring(0, 4) +
              d.data[chat].created_time.substring(5, 7) +
              d.data[chat].created_time.substring(8, 10) +
              d.data[chat].created_time.substring(11, 13) +
              d.data[chat].created_time.substring(14, 16) +
              d.data[chat].created_time.substring(17, 19)
            jsonData['createC'] = sss
            jsonData['testid'] = d.data[chat].testid

            logs.push(jsonData)
          }
          state.readLogs = logs
          state.chatLogsLoading = false
        })
        .catch((e) => {
        })
      // 読み込みメッセージのカウントアップ
      state.messagePages = pages
    },
    MAKE_DIALOG_CSV(state, data) {
      state.csvFile = null
      directtalk
        .makeDialogCSV(data)
        .then((d) => {
          const export_task_id = d.data.task_id

          // 1秒おきにエクスポート進捗を確認
          const checkJobStatus = () => {
            directtalk.checkMakeDialogCSV(export_task_id).then((d) => {
              if (d.data.completed) {
                state.csvFile = d.data.file_data
              }
              else {
                setTimeout(checkJobStatus, 1000)
              }
            })
            .catch((e) => {
              alert('会話履歴はございません。')
            })
          }
        
          checkJobStatus()
        })
    },
    UPLOAD_OCR(state, data) {
      state.isOCRReading = true
      directtalk
        .uploadOCR({ list: data })
        .then((d) => {
          state.ocrData = d.data
          state.isOCRReading = false
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
          alert(
            'エラーが発生しました。\nお手数をおかけし、誠にに申し訳ございませんが、\nアップロードした履歴書をsupport@hr-monster.ioまでご連携いただけますと幸いです'
          )
          location.reload()
        })
    },
    // 再構築 seekers
    CREATE_SEEKER(state, data) {
      state.seekers.unshift(data)
      return data
    },
    IMPORT_SEEKER(state, data) {
      state.seekers = data.concat(state.seekers)
    },
    GET_SEEKER(state, data) {
      if (!data.id) {
        state.seekers = data.data
      } else if (data.id.indexOf('scout') >= 0) {
        state.scoutSeekers = JSON.parse(data.data.data)
        state.scoutCount = data.data.count
      } else if (data.id.indexOf('subscribe') >= 0) {
        state.seekers = JSON.parse(data.data)
      }
      // state.getSeekerType = data.id
    },
    UPDATE_SEEKER(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.id) {
          state.filteredSeekers.splice(i, 1, data)
          state.filteredSeekers = state.filteredSeekers.filter((v) => v.is_delete_apply === false)
          return
        }
      }
    },
    DELETE_SEEKER(state, id) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === id) {
          state.filteredSeekers.splice(i, 1)
          return
        }
      }
    },
    // 資格API
    CREATE_QUALIFI(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.seeker) {
          state.filteredSeekers[i].qualification.push(data)
          return
        }
      }
    },
    GET_QUALIFI(state, data) {
      state.qualifications = data
    },
    UPDATE_QUALIFI(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.seeker) {
          for (let j in state.filteredSeekers[i].qualification) {
            if (state.filteredSeekers[i].qualification[j].pk === data.pk) {
              state.filteredSeekers[i].qualification.splice(j, 1, data)
              return
            }
          }
        }
      }
    },
    DELETE_QUALIFI(state, id) {
      for (let i in state.filteredSeekers) {
        for (let j in state.filteredSeekers[i].qualification) {
          if (state.filteredSeekers[i].qualification[j].pk === id) {
            state.filteredSeekers[i].qualification.splice(j, 1)
            return
          }
        }
      }
    },
    // 学歴・職歴API
    CREATE_CAREER(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.seeker) {
          state.filteredSeekers[i].career.push(data)
          return
        }
      }
    },
    GET_CAREER(state, data) {
      state.careers = data
    },
    UPDATE_CAREER(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.seeker) {
          for (let j in state.filteredSeekers[i].career) {
            if (state.filteredSeekers[i].career[j].pk === data.pk) {
              state.filteredSeekers[i].career.splice(j, 1, data)
              return
            }
          }
        }
      }
    },
    DELETE_CAREER(state, id) {
      for (let i in state.filteredSeekers) {
        for (let j in state.filteredSeekers[i].career) {
          if (state.filteredSeekers[i].career[j].pk === id) {
            state.filteredSeekers[i].career.splice(j, 1)
            return
          }
        }
      }
    },
    SET_PDF_CREATING(state, flg) {
      state.pdfCreating = flg
    },
    // ファイルAPI
    CREATE_SKFILES(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.seeker) {
          state.filteredSeekers[i].seeker_files.push(data)
          return
        }
      }
    },
    GET_SKFILES(state, data) {
      state.seekerfiles = data
    },
    UPDATE_SKFILES(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.seeker) {
          for (let j in state.filteredSeekers[i].seeker_files) {
            if (state.filteredSeekers[i].seeker_files[j].pk === data.pk) {
              state.filteredSeekers[i].seeker_files[j].splice(j, 1, data)
              return
            }
          }
        }
      }
    },
    DELETE_SKFILES(state, id) {
      for (let i in state.filteredSeekers) {
        for (let j in state.filteredSeekers[i].seeker_files) {
          if (state.filteredSeekers[i].seeker_files[j].pk === id) {
            state.filteredSeekers[i].seeker_files.splice(j, 1)
            return
          }
        }
      }
    },
    // SeekerCustomColumns API
    CREATE_SCOL(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.id) {
          state.filteredSeekers[i].custom_column.push(data.data)
          state.filteredSeekers[i].custom.push(data.data.pk)
          return
        }
      }
    },
    GET_SCOL(state, data) {
      state.customColumns = data
    },
    UPDATE_SCOL(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.id) {
          for (let j in state.filteredSeekers[i].custom_column) {
            if (state.filteredSeekers[i].custom_column[j].pk === data.data.pk) {
              state.filteredSeekers[i].custom_column.splice(j, 1, data.data)
              return
            }
          }
        }
      }
    },
    DELETE_SCOL(state, id) {
      for (let i in state.filteredSeekers) {
        for (let j in state.filteredSeekers[i].custom_column) {
          if (state.filteredSeekers[i].custom_column[j].pk === id) {
            state.filteredSeekers[i].custom_column.splice(j, 1)
            state.filteredSeekers[i].custom.splice(j, 1)
            return
          }
        }
      }
    },
    LOAD_CUSTOM(state, flg) {
      state.isSavingCustomColumn = flg
    },
    LOAD_SEEKER(state, data) {
      if (data.id === 'subscribe') {
        state.isSeekerLoading = data.flg
      } else {
        state.isScoutSeekerLoading = data.flg
      }
    },
    FILTER_ERR(state, flg) {
      state.isFilteringError = flg
    },
    setSeekerFilterItems(state, items) {
      state.seekerFilterItems = items
    },
    CSV_EXPORT(state, data) {
      state.isMakingCSV = true
      directtalk.csvExport(data)
        .then((d) => {
          const export_task_id = d.data.task_id

          // 1秒おきにエクスポート進捗を確認
          const checkJobStatus = () => {
            directtalk.checkCsvExport(export_task_id).then((d) => {
              if (d.data.completed) {
                state.downloadCSV = d.data.file_data
                var bom = new Uint8Array([0xef, 0xbb, 0xbf])
                var content = state.downloadCSV
                var blob = new Blob([bom, content], { type: 'text/csv' })
                if (window.navigator.msSaveBlob) {
                  window.navigator.msSaveBlob(blob, this.download)
                  window.navigator.msSaveOrOpenBlob(blob, this.download)
                } else {
                  var el = document.createElement('A')
                  el.download = '応募者データ.csv'
                  el.href = window.URL.createObjectURL(blob)
                  document.body.appendChild(el)
                  el.click()
                  document.body.removeChild(el)
                }
                state.isMakingCSV = false
              }
              else {
                setTimeout(checkJobStatus, 1000)
              }
            })
            .catch((e) => {
              if (e.response.status === 400) {
                alert('対象データが10,000件を超えるため、出力できません。\n期間を再指定して、エクスポート処理を行ってください。')
              } else {
                alert('エラーが発生いたしました。')
              }
              console.error(e)
              state.isMakingCSV = false
            })
          }
        
          checkJobStatus()
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          console.error(e)
          state.isMakingCSV = false
        })
    },
    SET_PARSED_SEEKER_DATA(state, data) {
      state.parsedSeekerData = data
    },
    setSeekerExportTemplateList(state, data) {
      state.seekerExportTemplates = data
    },
    setSeekerExportTemplate(state, {id, data}) {
      let index = state.seekerExportTemplates.findIndex((template) => template.id === id)
      if (index === -1) {
        if (data !== null) state.seekerExportTemplates.push(data)
      }
      else {
        if (data === null) state.seekerExportTemplates.splice(index, 1)
        else state.seekerExportTemplates.splice(index, 1, data)
      }
    },
    SEND_MLSK(state, flg) {
      state.isSendingEmail = flg
      state.isSendedSeeker = true
    },
    GET_EMAIL_LIST(state, data) {
      state.emailList = data.data
    },
    GET_EMAIL_LISTING(state, data) {
      state.emailListing = data;
    },
    GET_SMS_LISTING(state, data) {
      state.smsListing = data;
    },
    GET_ACTION_LISTING(state, data) {
      state.actionListing = data;
    },
    SEND_MESSAGE(state, data) {
      state.emailList.push(data.data)
    },
    SEND_MLSK_ERR(state) {
      state.isSendingEmail = false
    },
    // ScoutHistory API
    CREATE_SCTHIS(state, data) {
      for (let i in state.scoutSeekers) {
        if (state.scoutSeekers[i].id === data.seeker) {
          state.scoutSeekers[i].scout_history.push(data)
        }
      }
      state.scoutHistoryies.push(data)
    },
    GET_SCTHIS(state, data) {
      state.scoutHistoryies = data
    },
    UPDATE_SCTHIS(state, data) {
      for (let i in state.scoutSeekers) {
        if (state.scoutSeekers[i].id === data.seeker) {
          state.scoutSeekers[i].scout_history.pop()
          state.scoutSeekers[i].scout_history.push(data)
        }
      }
      for (let i in state.scoutHistoryies) {
        if (state.scoutHistoryies[i].pk === data.pk) {
          state.scoutHistoryies.splice(i, 1, data)
          return
        }
      }
    },
    DELETE_SCTHIS(state, { data, id }) {
      for (let i in state.scoutSeekers) {
        if (state.scoutSeekers[i].id === data.seeker) {
          state.scoutSeekers[i].scout_history.pop()
        }
      }
      for (let i in state.scoutHistoryies) {
        if (state.scoutHistoryies[i].pk === id) {
          state.scoutHistoryies.splice(i, 1)
          return
        }
      }
    },
    // RecruitmentFlowActionHistory API
    CREATE_RFACTHIS(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.seeker) {
          state.filteredSeekers[i].recruitment_flow_action_history.push(data)
        }
      }
      state.recruitmentFlowActionHistoryies.push(data)
    },
    GET_RFACTHIS(state, data) {
      state.recruitmentFlowActionHistoryies = data
    },
    UPDATE_RFACTHIS(state, data) {
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === data.seeker) {
          for (let j in state.filteredSeekers[i].recruitment_flow_action_history) {
            if (state.filteredSeekers[i].recruitment_flow_action_history[j].id === data.id) {
              state.filteredSeekers[i].recruitment_flow_action_history.splice(j, 1, data)
              return
            }
          }
        }
      }
    },
    DELETE_RFACTHIS(state, id) {
      for (let i in state.filteredSeekers) {
        for (let j in state.filteredSeekers[i].recruitment_flow_action_history) {
          if (state.filteredSeekers[i].recruitment_flow_action_history[j].pk === id) {
            state.filteredSeekers[i].recruitment_flow_action_history.splice(j, 1)
            return
          }
        }
      }
    },
    UNSUBSCRIBE_ACTION(state, seeker_id) {
      // 該当するseekerのアクション履歴を更新
      for (let i in state.filteredSeekers) {
        if (state.filteredSeekers[i].id === seeker_id) {
          // is_finished を true に設定
          state.filteredSeekers[i].recruitment_flow_action_history = 
            state.filteredSeekers[i].recruitment_flow_action_history.map(history => ({
              ...history,
              is_finished: true,
              finished_status: 9, // キャンセル状態
              error_log: "ユーザーにより配信停止されました"
            }))
        }
      }
    },    
    GET_EMAIL_ACT(state, data) {
      state.emailAction = data
      state.isEmailActionLoading = false
    },
    ERR_EMAIL_ACT(state, data) {
      state.isEmailActionError = true
      state.isEmailActionLoading = false
    },
    FETCH_SEEKER_INPUT_INFO(state, data) {
      state.seekerInputInfos = data
      state.cbInfoLoading = false
    },
    GET_COMPANY_DATA(state, data) {
      state.companyData.name = data.seeker_name
      state.companyData.subscribe_is_name = data.subscribe_is_name
      state.companyData.subscribe_is_email = data.subscribe_is_email
      state.companyData.subscribe_is_tel = data.subscribe_is_tel
      state.companyData.subscribe_is_name_phonetic = data.subscribe_is_name_phonetic
      state.companyData.subscribe_is_job_offer_no = data.subscribe_is_job_offer_no
      state.companyData.subscribe_is_sex = data.subscribe_is_sex
      state.companyData.subscribe_is_birth = data.subscribe_is_birth
      state.companyData.subscribe_is_address = data.subscribe_is_address
      state.companyData.subscribe_is_message = data.subscribe_is_message
      state.companyData.subscribe_list_message = data.subscribe_list_message
      state.companyData.subscribe_required_name = data.subscribe_required_name
      state.companyData.subscribe_required_email = data.subscribe_required_email
      state.companyData.subscribe_required_tel = data.subscribe_required_tel
      state.companyData.subscribe_required_name_phonetic = data.subscribe_required_name_phonetic
      state.companyData.subscribe_required_sex = data.subscribe_required_sex
      state.companyData.subscribe_required_birth = data.subscribe_required_birth
      state.companyData.subscribe_required_address = data.subscribe_required_address
      state.companyData.subscribe_required_message = data.subscribe_required_message
      state.isCompanyDataLoading = false
    },
    FETCH_SEEKER_REPLY(state, data) {
      state.seekerReplyList = data
    },
    SEND_SEEKER_CONTACT(state) {
      state.seekerContactDone = true
    },
    RESET_SEEKER_CONTACT_DONE(state) {
      state.seekerContactDone = false
    },
    FETCH_SEEKER_CONTACT(state, data) {
      state.seekerContactList = data
      state.cbContactLoading = false
    },
    CHANGE_SORT_FLG(state, flg) {
      state.sortFlg = flg
    },
    CHANGE_FILTER_FLG(state, flg) {
      state.filterFlg = flg
    },
    CLEAR_CHAT_HISTORY(state) {
      state.chatTalkHistory = []
    },
    RESTORE_TALK_HISTORY(state, id) {
      state.chatTalkHistory = JSON.parse(localStorage.getItem('talkhistory_' + id))
    },
    // RecordingInterview API
    CREATE_RI(state, data) {
      state.recordingInterviews.push(data)
    },
    GET_RI(state, data) {
      state.recordingInterviews = data
    },
    UPDATE_RI(state, data) {
      state.recordingInterviews = state.recordingInterviews.map((v) => (v.id == data.id ? data : v))
    },
    DELETE_RI(state, id) {
      state.recordingInterviews = state.recordingInterviews.filter((v) => v.id !== id)
    },
    //RecordingContent API
    CREATE_RC(state, data) {
      let index = _.findIndex(state.recordingInterviews, (obj) => {
        return obj.id === data.recording_inteview
      })
      state.recordingInterviews[index].recording_content.splice(Number(data.order), 0, data)
    },
    UPDATE_RC(state, data) {
      state.recordingInterviews.forEach((v, idx, arr) => {
        let index = _.findIndex(v.recording_content, (obj) => {
          return obj.id === data.id
        })
        if (index > -1) {
          state.recordingInterviews[idx].recording_content.splice(index, 1, data)
        }
      })
    },
    DELETE_RC(state, id) {
      state.recordingInterviews.forEach((v, idx, arr) => {
        let index = _.findIndex(v.recording_content, (obj) => {
          return obj.id === id
        })
        if (index > -1) {
          state.recordingInterviews[idx].recording_content.splice(index, 1)
        }
      })
    },
    GET_RA(state, data) {
      state.answerRecord = data
    },
    UPDATE_RA(state, data) {
      for (const i in state.answerRecord) {
        if (state.answerRecord[i].id == data.content.id) {
          state.answerRecord[i].read_user = data.content.read_user
        }
      }
      if (data.change == 'read') {
        const read_data = { id: data.content.id, read_user: data.content.read_user }
        state.recordingInterviews.forEach((v1, idx1, arr1) => {
          v1.recording_content.forEach((v2, idx2, arr2) => {
            let index = _.findIndex(v2.recording_answer, (obj) => {
              return obj.id === read_data.id
            })
            if (index > -1) {
              state.recordingInterviews[idx1].recording_content[idx2].recording_answer.splice(
                index,
                1,
                read_data
              )
            }
          })
        })
      }
    },
    UPDATE_RS(state, data) {
      let change_data = {}
      for (const i in state.answerRecord) {
        if (
          state.answerRecord[i].answer_name == data.name &&
          state.answerRecord[i].answer_email == data.email
        ) {
          change_data = state.answerRecord[i]
          change_data.seeker = data.seeker.id
          change_data.seeker_data = data.seeker
          state.answerRecord.splice(i, 1, change_data)
        }
      }
    },
    GET_RD(state, data) {
      state.detailRecord = data
    },

    INIT_LOGS(state) {
      state.chatLogs = []
    },
    SET_CHAT_LOGS_LOADING(state, isLoading) {
      state.chatLogsLoading = isLoading
    },
    REFLESH_SEEKER_COLUMN(state) {
      state.isSeekerLoading = true
      state.isSeekerLoading = false
    },
    GET_SDM(state, data) {
      state.detailManage = data
    },
    SET_ROBO_ARG(state, argList) {
      state.roboArguments = argList
    },
    SET_AGGREGATE_RESULT(state, data) {
      state.aggregateResult = data;
    },
    SET_COMPANY_COLUMN_RESULT(state, data) {
      state.companyColumnResult = data;
    },
    SET_AGGREGATED_MESSAGES_RESULT(state, data) {
      state.aggregatedMessagesResult = data;
    },
    SET_SEEKER_SUMMARY_TABLE2_RESULT(state, data) {
      state.seekerSummaryTable2Result = data;
    },
    SET_FILTER_OPTIONS(state, data) {
      state.filterOptions = data;
    },
    SET_YEAR_MONTH_RANGE(state, data) {
      state.yearMonthRange = data;
    },  
    SET_SEEKER_SUMMARY(state, data) {
      state.seekerSummary = data;
    },
    SET_SEEKER_INFO(state, data) {
      // 新しいSeeker情報でstateを更新
      state.seeker = data;
    },
    SET_ROOM_DATA(state, data) {
      // 新しいRoom情報でstateを更新
      if (state.selectroom) {
        state.selectroom.id = data.id;
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/directtalk.js